export default {
  en: {
    "system.label.ManageMessage": "Manage Message",
    "system.label.Role": "Role",
    "system.label.Enabled": "Enabled",
    "system.label.Enter_service_Description": "Enter service description",
    "system.label.Manage_Report": "Manage Report",
    "system.label.Reports": "Reports",
    "system.label.Create": "Create",
    "system.label.Edit": "Edit",
    "system.label.Calendar": "Calendar",
    "system.label.Delete": "Delete",
    "system.label.assignedRoles": "Assigned Roles",
    "system.label.role": "Role",
    "system.label.clientName": "Client Name",
    "system.label.editRole": "Edit Role",
    "system.label.selectClient": "Select Client",
    "system.label.roleName": "Role Name",
    "system.label.roleDescription": "Role Description",
    "system.label.NetworkSystem": "Network System",
    "system.label.ManageCode": "Manage Code",
    "system.label.Add": "Add",
    "system.label.ViewShift": "View Shift",
    "system.label.HolidayManagement": "Holiday Management",
    "system.label.CreateHoliday": "Create Holiday",
    "system.label.EditHoliday": "Edit Holiday",
    "system.label.ViewHoliday": "View Holiday",
    "system.label.HolidayTitle": "Holiday Title",
    "system.label.Days": "Days",
    "system.label.HolidayType": "Holiday Type",
    "system.label.comment": "Comment",
    "system.label.WeeklyHolidays": "Weekly Holidays",
    "system.label.SessionName": "Session Name",
    "system.label.SessionDate": "Session Date",
    "system.label.ViewEventActionMapping": "View Event Action Mapping",
    "system.label.Event": "Event",
    "system.label.Action": "Action",
    "system.label.OrderBY": "Order By",
    "system.label.ProcessParams": "Process Params",
    "system.label.AddConfiguration": "Add Configuration",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "ENUM Name",
    "system.label.ENUM_Id": "ENUM ID",
    "system.label.ENUM_Property": "ENUM Property",
    "system.label.ENUM_Value": "ENUM Value",
    "system.label.Create_Enum": "Create Enum",
    "system.label.ExternalSystem": "External System",
    "system.label.CreateDevice": "Create Device",
    "system.label.ExternalSystem": "External System",
    "system.label.userName": "User Name",
    "system.label.firstName": "First Name",
    "system.label.lastName": "Last Name",
    "system.label.email": "Email",
    "system.label.officeName": "Office Name",
    "system.label.action": "Actions",
    "system.label.createUser": "Create User",
    "system.label.users": "Users",
    "system.label.View": "View",
    "system.label.itemdescription": "Item Description",
    "system.label.Property": "Property",
    "system.label.edit": "Edit",
    "system.label.delete": "Delete",
    "system.label.loginName": "Login Name",
    "system.label.entityName": "Business Entity Name",
    "system.label.roles": "Roles",
    "system.label.changePassword": "Change Password",
    "system.label.password": "Password",
    "system.label.repeatPassword": "Repeat Password",
    "system.label.cancel": "Cancel",
    "system.label.save": "Save",
    "system.label.deleteUser": "Delete User",
    "system.label.areYouSure": "Are you sure?",
    "system.label.ok": "Ok",
    "system.label.editUser": "Edit User",
    "system.label.availableRoles": "Available Roles",
    "system.label.selectedRoles": "Selected Roles",
    "system.label.entity": " Business Entity",
    "system.label.submit": "Submit",
    "system.label.createUser": "Create User",
    "system.label.autoGeneratePassword": "Auto Generate Password",
    "system.label.reset": "Reset",
    "system.label.areYouSureDelete": "Are you sure you want to delete?",
    "system.label.confirm": "Confirm",
    "system.label.createRole": "Create Role",
    "system.label.name": "Name",
    "system.label.description": "Description",
    "system.label.permissions": "Permissions",
    "system.label.currencyConfig": "Currency Config",
    "system.label.createCurrency": "Create Currency",
    "system.label.code": "Code",
    "system.label.internationalNameCode": "International Name Code",
    "system.label.decimalPlaces": "Decimal Places",
    "system.label.displaySymbol": "Display Symbol",
    "system.label.viewCurrency": "View Currency",
    "system.label.countryCode": "Country Code",
    "system.label.countryName": "Country Name",
    "system.label.displaySymbol": "Display Symbol",
    "system.label.createCurrencyMaster": "Create Currency Master",
    "system.label.currency": "Currency",
    "system.label.nonCurrency": "Non-Currency",
    "system.label.editCurrencyConfiguration": "Edit Currency Configuration",
    "system.label.deleteCurrency": "Delete Currency",
    "system.label.deleteNonCurrency": "Delete Non-Currency",
    "system.label.areYouSureDelete": "Are you sure you want to delete?",
    "system.label.currencyExchange": "Currency Exchange",
    "system.label.createExchange": "Create Exchange",
    "system.label.id": "Id",
    "system.label.baseCurrency": "Base Currency",
    "system.label.conversionCurrency": "Conversion Currency",
    "system.label.conversionRate": "Conversion Rate",
    "system.label.status": "Status",
    "system.label.validFrom": "Valid From",
    "system.label.validTo": "Valid To",
    "system.label.deleteCurrencyExchange": "Delete Currency Exchange",
    "system.label.viewCurrencyExchange": "View Currency Exchange",
    "system.label.createCurrencyExchange": "Create Currency Exchange",
    "system.label.editCurrencyExchange": "Edit Currency Exchange",
    "system.label.GlobalConfiguration": "Global Configuration",
    "system.label.Module": "Module",
    "system.label.Name": "Name",
    "system.label.Description": "Description",
    "system.label.Value": "Value",
    "system.label.Enabled": "Enabled",
    "system.label.Flag": "Flag",
    "system.label.Action": "Action",
    "system.label.EditGlobalConfiguration": "Edit Global Configuration",
    "system.label.PaymentGatewayConfiguration": "Payment Gateway Configuration",
    "system.label.EditPaymentGatewayConfiguration":
      "Edit Payment Gateway Configuration",
    "system.label.Key": "Key",
    "system.label.EnterKeyHere": "Enter key here",
    "system.label.EnterValueHere": "Enter value here",
    "system.label.Hooks": "Hooks",
    "system.label.Event": "Event",
    "system.label.Name": "Name",
    "system.label.Description": "Description",
    "system.label.Value": "Value",
    "system.label.Enabled": "Enabled",
    "system.label.Flag": "Flag",
    "system.label.Action": "Action",
    "system.label.Process": "Process",
    "system.label.OrderBy": "Order By",
    "system.label.PrePost": "PrePost",
    "system.label.ProcessParams": "Process Params",
    "system.label.IsSynchronous": "Is synchronous",
    "system.label.Actions": "Actions",
    "system.label.CreateEvent": "Create Event",
    "system.label.CreateEventActionMapping": "Create Event Action Mapping",
    "system.label.AutoGeneratePassword": "Auto Generate Password",
    "system.label.EditEventActionMapping": "Edit Event Action Mapping",
    "system.label.ProvisioningDevice": "Provisioning Device",
    "system.label.ItemClass": "Item Class",
    "system.label.ProvisioningSystem": "Provisioning System",
    "system.label.Create": "Create",
    "system.label.CreateHardwarePlan": "Create Hardware Plan",
    "system.label.EditHardwarePlan": "Edit Hardware Plan",
    "system.label.ProvisionCommand": "Provision Command",
    "system.label.ProvisioningSystem": "Provisioning System",
    "system.label.CommandName": "Command Name",
    "system.label.Status": "Status",
    "system.label.Parameters": "Parameters",
    "system.label.CreateProvisioningMapping": "Create Provisioning Mapping",
    "system.label.CommandParams": "Command Params",
    "system.label.ParamDefault": "Param Default",
    "system.label.ParamLength": "Param Length",
    "system.label.ParamNotes": "Param Notes",
    "system.label.ParamType": "Param Type",
    "system.label.AutoGenerate": "Auto Generate",
    "system.label.ViewProvisioningMapping": "View Provisioning Mapping",
    "system.label.CommandParameter": "Command Parameter",
    "system.label.Edit": "Edit",
    "system.label.Delete": "Delete",
    "system.label.DeleteProvisionCommand": "Delete Provision Command",
    "system.label.AreYouSure": "Are you sure?",
    "system.label.Ok": "Ok",
    "system.label.EditProvisioningMapping": "Edit Provisioning Mapping",
    "system.label.Id": "Id",
    "system.label.ParamName": "Param Name",
    "system.label.ProvisioningActions": "Provisioning Actions",
    "system.label.ProvisionType": "Provision Type",
    "system.label.IsEnable": "Is Enable",
    "system.label.NetworkSystem": "Network System",
    "system.label.SystemCode": "System Code",
    "system.label.SystemName": "System Name",
    "system.label.CreateNetworkSystem": "Create Network System",
    "system.label.GroupSupported": "Group Supported",
    "system.label.EditNetworkSystem": "Edit Network System",
    "system.label.DeleteNetworkSystem": "Delete Network System",
    "system.label.ManageReports": "Manage Reports",
    "system.label.ReportName": "Report Name",
    "system.label.AddressMasterTreeView": "Address Master Tree View",
    "system.label.ReportType": "Report Type",
    "system.label.ReportSubtype": "Report Subtype",
    "system.label.ReportCategory": "Report Category",
    "system.label.CoreReport": "Core Report",
    "system.label.UserReport": "User Report",
    "system.label.CreateReport": "Create Report",
    "system.label.ReportDetails": "Report Details",
    "system.label.UserReportUI": "User Report (UI)",
    "system.label.isScheduled": "is Scheduled",
    "system.label.Description": "Description",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "REPORT PARAMETERS",
    "system.label.AllowedParameters": "Allowed Parameters",
    "system.label.CreateParameter": "Create Parameter",
    "system.label.Parameter": "Parameter",
    "system.label.ParameterNamePassedToPentaoh":
      "Parameter Name Passed To Pentaoh",
    "system.label.Reset": "Reset",
    "system.label.EditReport": "Edit Report",
    "system.label.DeleteReports": "Delete Reports",
    "system.label.ManageCodes": "Manage Codes",
    "system.label.CodeModule": "Code Module",
    "system.label.SystemDefined": "System Defined",
    "system.label.CreateCode": "Create Code",
    "system.label.AddCode": "Add Code",
    "system.label.Module": "Module",
    "system.label.EditManageCodes": "Edit Manage Codes",
    "system.label.CodeValue": "Code Value",
    "system.label.Position": "Position",
    "system.label.Create": "Create",
    "system.label.DeleteManageCodes": "Delete Manage Codes",
    "system.label.ViewManageCodes": "View Manage Codes",
    "system.label.Name": "Name",
    "system.label.Add": "Add",
    "system.label.CodeName": "Code Name",
    "system.label.Submit": "Submit",
    "system.label.isSynchronous": "Is Synchronous",

    "system.label.EnterServiceDescription": "Enter service Description",
    "system.label.Questions": "Questions",
    "system.label.Id": "Id",
    "system.label.QuestionType": "Question Type",
    "system.label.QuestionText": "Question Text",
  },

  fr: {
    "system.label.ManageMessage": "Gérer le message",
    "system.label.Role": "Rôle",
    "system.label.Enabled": "Activé",
    "system.label.Enter_service_Description":
      "Entrez la description du service",
    "system.label.Manage_Report": "Gérer le rapport",
    "system.label.Reports": "Rapports",
    "system.label.Create": "Créer",
    "system.label.Edit": "Modifier",
    "system.label.Delete": "Supprimer",
    "system.label.role": "Rôle",
    "system.label.clientName": "Nom du client",
    "system.label.assignedRoles": "Rôles attribués",
    "system.label.editRole": "Modifier le rôle",
    "system.label.NetworkSystem": "Système Réseau",
    "system.label.ManageCode": "Gérer le code",
    "system.label.ViewShift": "Voir le quart",
    "system.label.HolidayManagement": "Gestion des congés",
    "system.label.CreateHoliday": "Créer un congé",
    "system.label.EditHoliday": "Modifier le congé",
    "system.label.ViewHoliday": "Voir le congé",
    "system.label.HolidayTitle": "Titre du congé",
    "system.label.Days": "Jours",
    "system.label.HolidayType": "Type de congé",
    "system.label.WeeklyHolidays": "Congés hebdomadaires",
    "system.label.SessionName": "Nom de la session",
    "system.label.SessionDate": "Date de la session",
    "system.label.Add": "Ajouter",
    "system.label.ViewEventActionMapping":
      "Afficher la correspondance des actions d'événement",
    "system.label.Event": "Événement",
    "system.label.Action": "Action",
    "system.label.OrderBY": "Ordre",
    "system.label.ProcessParams": "Paramètres de traitement",
    "system.label.AddConfiguration": "Ajouter une configuration",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "Nom ENUM",
    "system.label.ENUM_Id": "ID ENUM",
    "system.label.ENUM_Property": "Propriété ENUM",
    "system.label.ENUM_Value": "Valeur ENUM",
    "system.label.Create_Enum": "Créer ENUM",
    "system.label.ExternalSystem": "Système externe",
    "system.label.CreateDevice": "Créer un appareil",
    "system.label.ExternalSystem": "Système Externe",
    "system.label.userName": "Nom d'utilisateur",
    "system.label.firstName": "Prénom",
    "system.label.lastName": "Nom de famille",
    "system.label.email": "Email",
    "system.label.officeName": "Nom du bureau",
    "system.label.action": "Action",
    "system.label.createUser": "Créer un utilisateur",
    "system.label.users": "Utilisateurs",
    "system.label.View": "Voir",
    "system.label.Property": "Propriété",
    "system.label.edit": "Modifier",
    "system.label.delete": "Supprimer",
    "system.label.loginName": "Nom de connexion",
    "system.label.entityName": "Nom de l'entité",
    "system.label.roles": "Rôles",
    "system.label.changePassword": "Changer le mot de passe",
    "system.label.password": "Mot de passe",
    "system.label.repeatPassword": "Répéter le mot de passe",
    "system.label.cancel": "Annuler",
    "system.label.itemdescription": "Description de l'Article",
    "system.label.save": "Enregistrer",
    "system.label.deleteUser": "Supprimer l'utilisateur",
    "system.label.areYouSure": "Êtes-vous sûr ?",
    "system.label.ok": "Ok",
    "system.label.editUser": "Modifier l'utilisateur",
    "system.label.availableRoles": "Rôles disponibles",
    "system.label.selectedRoles": "Rôles sélectionnés",
    "system.label.entity": "Entité",
    "system.label.submit": "Soumettre",
    "system.label.createUser": "Créer un utilisateur",
    "system.label.autoGeneratePassword":
      "Générer automatiquement le mot de passe",
    "system.label.reset": "Réinitialiser",
    "system.label.areYouSureDelete": "Êtes-vous sûr de vouloir supprimer ?",
    "system.label.confirm": "Confirmer",
    "system.label.createRole": "Créer un rôle",
    "system.label.name": "Nom",
    "system.label.description": "Description",
    "system.label.permissions": "Permissions",
    "system.label.currencyConfig": "Configuration des devises",
    "system.label.createCurrency": "Créer une devise",
    "system.label.code": "Code",
    "system.label.internationalNameCode": "Code de nom international",
    "system.label.decimalPlaces": "Décimales",
    "system.label.displaySymbol": "Symbole d'affichage",
    "system.label.viewCurrency": "Voir la devise",
    "system.label.countryCode": "Code pays",
    "system.label.countryName": "Nom du pays",
    "system.label.displaySymbol": "Symbole d'affichage",
    "system.label.createCurrencyMaster": "Créer un maître de devise",
    "system.label.currency": "Devise",
    "system.label.nonCurrency": "Non-Devise",
    "system.label.editCurrencyConfiguration":
      "Modifier la configuration de la devise",
    "system.label.deleteCurrency": "Supprimer la devise",
    "system.label.deleteNonCurrency": "Supprimer Non-Monnaie",
    "system.label.areYouSureDelete": "Êtes-vous sûr de vouloir supprimer ?",
    "system.label.currencyExchange": "Échange de devises",
    "system.label.createExchange": "Créer un échange",
    "system.label.id": "Id",
    "system.label.baseCurrency": "Devise de base",
    "system.label.conversionCurrency": "Devise de conversion",
    "system.label.conversionRate": "Taux de conversion",
    "system.label.status": "Statut",
    "system.label.validFrom": "Valide à partir de",
    "system.label.validTo": "Valide jusqu'à",
    "system.label.deleteCurrencyExchange": "Supprimer l'échange de devises",
    "system.label.viewCurrencyExchange": "Voir l'échange de devises",
    "system.label.createCurrencyExchange": "Créer un échange de devises",
    "system.label.editCurrencyExchange": "Modifier l'échange de devises",
    "system.label.GlobalConfiguration": "Configuration globale",
    "system.label.Module": "Module",
    "system.label.Name": "Nom",
    "system.label.Description": "Description",
    "system.label.Value": "Valeur",
    "system.label.Enabled": "Activé",
    "system.label.Flag": "Drapeau",
    "system.label.Action": "Action",
    "system.label.EditGlobalConfiguration": "Modifier la configuration globale",
    "system.label.PaymentGatewayConfiguration":
      "Configuration de la passerelle de paiement",
    "system.label.EditPaymentGatewayConfiguration":
      "Modifier la configuration de la passerelle de paiement",
    "system.label.Key": "Clé",
    "system.label.EnterKeyHere": "Entrez la clé ici",
    "system.label.EnterValueHere": "Entrez la valeur ici",
    "system.label.Hooks": "Hooks",
    "system.label.Event": "Événement",
    "system.label.Name": "Nom",
    "system.label.Description": "Description",
    "system.label.Value": "Valeur",
    "system.label.Enabled": "Activé",
    "system.label.Flag": "Drapeau",
    "system.label.Action": "Action",
    "system.label.Process": "Processus",
    "system.label.OrderBy": "Ordre Par",
    "system.label.PrePost": "PréPost",
    "system.label.ProcessParams": "Paramètres du processus",
    "system.label.IsSynchronous": "Est synchrone",
    "system.label.Actions": "Actions",
    "system.label.CreateEvent": "Créer un événement",
    "system.label.CreateEventActionMapping":
      "Créer une correspondance d'action d'événement",
    "system.label.AutoGeneratePassword":
      "Génération automatique du mot de passe",
    "system.label.EditEventActionMapping":
      "Modifier la correspondance d'action d'événement",
    "system.label.ProvisioningDevice": "Dispositif de Provisioning",
    "system.label.ItemClass": "Classe d'Objet",
    "system.label.ProvisioningSystem": "Système de Provisioning",
    "system.label.Create": "Créer",
    "system.label.CreateHardwarePlan": "Créer un Plan Matériel",
    "system.label.EditHardwarePlan": "Modifier le Plan Matériel",
    "system.label.ProvisionCommand": "Commande de Provisioning",
    "system.label.ProvisioningSystem": "Système de Provisioning",
    "system.label.CommandName": "Nom de la Commande",
    "system.label.Status": "Statut",
    "system.label.Parameters": "Paramètres",
    "system.label.CreateProvisioningMapping":
      "Créer une Correspondance de Provisioning",
    "system.label.CommandParams": "Paramètres de la Commande",
    "system.label.ParamDefault": "Valeur Par Défaut du Paramètre",
    "system.label.ParamLength": "Longueur du Paramètre",
    "system.label.ParamNotes": "Notes sur le Paramètre",
    "system.label.ParamType": "Type de Paramètre",
    "system.label.AutoGenerate": "Générer Automatiquement",
    "system.label.ViewProvisioningMapping":
      "Voir la Correspondance de Provisioning",
    "system.label.CommandParameter": "Paramètre de la Commande",
    "system.label.Edit": "Modifier",
    "system.label.Delete": "Supprimer",
    "system.label.DeleteProvisionCommand":
      "Supprimer la Commande de Provisioning",
    "system.label.AreYouSure": "Êtes-vous sûr ?",
    "system.label.Ok": "Ok",
    "system.label.EditProvisioningMapping":
      "Modifier la Correspondance de Provisioning",
    "system.label.Id": "Id",
    "system.label.ParamName": "Nom du Paramètre",
    "system.label.ProvisioningActions": "Actions de Provisioning",
    "system.label.ProvisionType": "Type de Provisioning",
    "system.label.IsEnable": "Est Activé",
    "system.label.NetworkSystem": "Système Réseau",
    "system.label.SystemCode": "Code du Système",
    "system.label.SystemName": "Nom du Système",
    "system.label.CreateNetworkSystem": "Créer un Système Réseau",
    "system.label.GroupSupported": "Groupe Supporté",
    "system.label.EditNetworkSystem": "Modifier le Système Réseau",
    "system.label.DeleteNetworkSystem": "Supprimer le Système Réseau",
    "system.label.ManageReports": "Gérer les Rapports",
    "system.label.ReportName": "Nom du Rapport",
    "system.label.AddressMasterTreeView":
      "Vue Arborescente du Maître d'Adresse",
    "system.label.ReportType": "Type de Rapport",
    "system.label.ReportSubtype": "Sous-type de Rapport",
    "system.label.ReportCategory": "Catégorie de Rapport",
    "system.label.CoreReport": "Rapport Principal",
    "system.label.UserReport": "Rapport Utilisateur",
    "system.label.CreateReport": "Créer un Rapport",
    "system.label.ReportDetails": "Détails du Rapport",
    "system.label.UserReportUI": "Rapport Utilisateur (UI)",
    "system.label.isScheduled": "est Programmé",
    "system.label.Description": "Description",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "PARAMÈTRES DU RAPPORT",
    "system.label.AllowedParameters": "Paramètres Autorisés",
    "system.label.CreateParameter": "Créer un Paramètre",
    "system.label.Parameter": "Paramètre",
    "system.label.ParameterNamePassedToPentaoh":
      "Nom du Paramètre Transmis à Pentaoh",
    "system.label.Reset": "Réinitialiser",
    "system.label.EditReport": "Modifier le Rapport",
    "system.label.DeleteReports": "Supprimer les Rapports",
    "system.label.ManageCodes": "Gérer les Codes",
    "system.label.CodeModule": "Module de Code",
    "system.label.SystemDefined": "Défini par le Système",
    "system.label.CreateCode": "Créer du code",
    "system.label.AddCode": "Ajouter un Code",
    "system.label.Module": "Module",
    "system.label.EditManageCodes": "Modifier la Gestion des Codes",
    "system.label.CodeValue": "Valeur du Code",
    "system.label.Position": "Position",
    "system.label.Create": "Créer",
    "system.label.DeleteManageCodes": "Supprimer la Gestion des Codes",
    "system.label.ViewManageCodes": "Voir la Gestion des Codes",
    "system.label.Name": "Nom",
    "system.label.Add": "Ajouter",
    "system.label.CodeName": "Nom du Code",
    "system.label.Submit": "Soumettre",
    "system.label.isSynchronous": "Est synchrone",

    "system.label.EnterServiceDescription": "Entrez la description du service",
    "system.label.Questions": "Questions",
    "system.label.Id": "ID",
    "system.label.QuestionType": "Type de question",
    "system.label.QuestionText": "Texte de la question",
  },

  es: {
    "system.label.ManageMessage": "Gestionar mensaje",
    "system.label.Role": "Rol",
    "system.label.Enabled": "Habilitado",
    "system.label.Enter_service_Description":
      "Ingrese la descripción del servicio",
    "system.label.Manage_Report": "Gestionar informe",
    "system.label.Reports": "Informes",
    "system.label.Create": "Crear",
    "system.label.Edit": "Editar",
    "system.label.Delete": "Eliminar",
    "system.label.role": "Rol",
    "system.label.clientName": "Nombre del Cliente",
    "system.label.assignedRoles": "Roles asignados",
    "system.label.editRole": "Editar Rol",
    "system.label.NetworkSystem": "Sistema de Red",
    "system.label.ManageCode": "Gestionar código",
    "system.label.ViewShift": "Ver turno",
    "system.label.HolidayManagement": "Gestión de vacaciones",
    "system.label.CreateHoliday": "Crear vacaciones",
    "system.label.EditHoliday": "Editar vacaciones",
    "system.label.ViewHoliday": "Ver vacaciones",
    "system.label.HolidayTitle": "Título de las vacaciones",
    "system.label.Days": "Días",
    "system.label.HolidayType": "Tipo de vacaciones",
    "system.label.WeeklyHolidays": "Días festivos semanales",
    "system.label.SessionName": "Nombre de la sesión",
    "system.label.SessionDate": "Fecha de la sesión",
    "system.label.Add": "Agregar",
    "system.label.ViewEventActionMapping": "Ver asignación de acción de evento",
    "system.label.Event": "Evento",
    "system.label.Action": "Acción",
    "system.label.OrderBY": "Ordenar por",
    "system.label.ProcessParams": "Parámetros de proceso",
    "system.label.AddConfiguration": "Agregar configuración",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "Nombre ENUM",
    "system.label.ENUM_Id": "ID ENUM",
    "system.label.ENUM_Property": "Propiedad ENUM",
    "system.label.ENUM_Value": "Valor ENUM",
    "system.label.Create_Enum": "Crear ENUM",
    "system.label.ExternalSystem": "Sistema externo",
    "system.label.CreateDevice": "Crear dispositivo",
    "system.label.ExternalSystem": "Sistema Externo",
    "system.label.userName": "Nombre de usuario",
    "system.label.firstName": "Nombre",
    "system.label.lastName": "Apellido",
    "system.label.email": "Email",
    "system.label.officeName": "Nombre de la oficina",
    "system.label.action": "Acción",
    "system.label.createUser": "Crear usuario",
    "system.label.users": "Usuarios",
    "system.label.View": "Ver",
    "system.label.Property": "Propiedad",
    "system.label.edit": "Editar",
    "system.label.delete": "Eliminar",
    "system.label.loginName": "Nombre de inicio de sesión",
    "system.label.entityName": "Nombre de la entidad",
    "system.label.roles": "Roles",
    "system.label.changePassword": "Cambiar contraseña",
    "system.label.password": "Contraseña",
    "system.label.repeatPassword": "Repetir contraseña",
    "system.label.cancel": "Cancelar",
    "system.label.itemdescription": "Descripción del Artículo",
    "system.label.save": "Guardar",
    "system.label.deleteUser": "Eliminar usuario",
    "system.label.areYouSure": "¿Estás seguro?",
    "system.label.ok": "Ok",
    "system.label.editUser": "Editar usuario",
    "system.label.availableRoles": "Roles disponibles",
    "system.label.selectedRoles": "Roles seleccionados",
    "system.label.entity": "Entidad",
    "system.label.submit": "Enviar",
    "system.label.createUser": "Crear usuario",
    "system.label.autoGeneratePassword": "Generar contraseña automáticamente",
    "system.label.reset": "Restablecer",
    "system.label.areYouSureDelete": "¿Estás seguro de que quieres eliminar?",
    "system.label.confirm": "Confirmar",
    "system.label.createRole": "Crear Rol",
    "system.label.name": "Nombre",
    "system.label.description": "Descripción",
    "system.label.permissions": "Permisos",
    "system.label.currencyConfig": "Configuración de moneda",
    "system.label.createCurrency": "Crear moneda",
    "system.label.code": "Código",
    "system.label.internationalNameCode": "Código de nombre internacional",
    "system.label.decimalPlaces": "Decimales",
    "system.label.displaySymbol": "Símbolo de visualización",
    "system.label.viewCurrency": "Ver moneda",
    "system.label.countryCode": "Código de país",
    "system.label.countryName": "Nombre del país",
    "system.label.displaySymbol": "Símbolo de visualización",
    "system.label.createCurrencyMaster": "Crear maestro de moneda",
    "system.label.currency": "Moneda",
    "system.label.nonCurrency": "No moneda",
    "system.label.editCurrencyConfiguration": "Editar configuración de moneda",
    "system.label.deleteCurrency": "Eliminar moneda",
    "system.label.deleteNonCurrency": "Eliminar No Moneda",
    "system.label.areYouSureDelete": "¿Estás seguro de que quieres eliminar?",
    "system.label.currencyExchange": "Intercambio de divisas",
    "system.label.createExchange": "Crear intercambio",
    "system.label.id": "Id",
    "system.label.baseCurrency": "Moneda base",
    "system.label.conversionCurrency": "Moneda de conversión",
    "system.label.conversionRate": "Tipo de cambio",
    "system.label.status": "Estado",
    "system.label.validFrom": "Válido desde",
    "system.label.validTo": "Válido hasta",
    "system.label.deleteCurrencyExchange": "Eliminar intercambio de divisas",
    "system.label.viewCurrencyExchange": "Ver intercambio de divisas",
    "system.label.createCurrencyExchange": "Crear intercambio de divisas",
    "system.label.editCurrencyExchange": "Editar intercambio de divisas",
    "system.label.GlobalConfiguration": "Configuración global",
    "system.label.Module": "Módulo",
    "system.label.Name": "Nombre",
    "system.label.Description": "Descripción",
    "system.label.Value": "Valor",
    "system.label.Enabled": "Habilitado",
    "system.label.Flag": "Bandera",
    "system.label.Action": "Acción",
    "system.label.EditGlobalConfiguration": "Editar configuración global",
    "system.label.PaymentGatewayConfiguration":
      "Configuración de la pasarela de pago",
    "system.label.EditPaymentGatewayConfiguration":
      "Editar configuración de la pasarela de pago",
    "system.label.Key": "Clave",
    "system.label.EnterKeyHere": "Ingrese la clave aquí",
    "system.label.EnterValueHere": "Ingrese el valor aquí",
    "system.label.Hooks": "Hooks",
    "system.label.Event": "Evento",
    "system.label.Name": "Nombre",
    "system.label.Description": "Descripción",
    "system.label.Value": "Valor",
    "system.label.Enabled": "Habilitado",
    "system.label.Flag": "Bandera",
    "system.label.Action": "Acción",
    "system.label.Process": "Proceso",
    "system.label.OrderBy": "Ordenar Por",
    "system.label.PrePost": "PrePost",
    "system.label.ProcessParams": "Parámetros del proceso",
    "system.label.IsSynchronous": "Es sincrónico",
    "system.label.Actions": "Acciones",
    "system.label.CreateEvent": "Crear evento",
    "system.label.CreateEventActionMapping":
      "Crear asignación de acción de evento",
    "system.label.AutoGeneratePassword": "Generar contraseña automáticamente",
    "system.label.EditEventActionMapping":
      "Editar asignación de acción de evento",
    "system.label.ProvisioningDevice": "Dispositivo de Provisionamiento",
    "system.label.ItemClass": "Clase de Artículo",
    "system.label.ProvisioningSystem": "Sistema de Provisionamiento",
    "system.label.Create": "Crear",
    "system.label.CreateHardwarePlan": "Crear Plan de Hardware",
    "system.label.EditHardwarePlan": "Editar Plan de Hardware",
    "system.label.ProvisionCommand": "Comando de Provisionamiento",
    "system.label.ProvisioningSystem": "Sistema de Provisionamiento",
    "system.label.CommandName": "Nombre del Comando",
    "system.label.Status": "Estado",
    "system.label.Parameters": "Parámetros",
    "system.label.CreateProvisioningMapping": "Crear Mapeo de Provisionamiento",
    "system.label.CommandParams": "Parámetros del Comando",
    "system.label.ParamDefault": "Valor Predeterminado del Parámetro",
    "system.label.ParamLength": "Longitud del Parámetro",
    "system.label.ParamNotes": "Notas del Parámetro",
    "system.label.ParamType": "Tipo de Parámetro",
    "system.label.AutoGenerate": "Generar Automáticamente",
    "system.label.ViewProvisioningMapping": "Ver Mapeo de Provisionamiento",
    "system.label.CommandParameter": "Parámetro del Comando",
    "system.label.Edit": "Editar",
    "system.label.Delete": "Eliminar",
    "system.label.DeleteProvisionCommand":
      "Eliminar Comando de Provisionamiento",
    "system.label.AreYouSure": "¿Estás seguro?",
    "system.label.Ok": "Ok",
    "system.label.EditProvisioningMapping": "Editar Mapeo de Provisionamiento",
    "system.label.Id": "Id",
    "system.label.ParamName": "Nombre del Parámetro",
    "system.label.ProvisioningActions": "Acciones de Provisionamiento",
    "system.label.ProvisionType": "Tipo de Provisionamiento",
    "system.label.IsEnable": "Está Habilitado",
    "system.label.NetworkSystem": "Sistema de Red",
    "system.label.SystemCode": "Código del Sistema",
    "system.label.SystemName": "Nombre del Sistema",
    "system.label.CreateNetworkSystem": "Crear Sistema de Red",
    "system.label.GroupSupported": "Grupo Soportado",
    "system.label.EditNetworkSystem": "Editar Sistema de Red",
    "system.label.DeleteNetworkSystem": "Eliminar Sistema de Red",
    "system.label.ManageReports": "Gestionar Informes",
    "system.label.ReportName": "Nombre del Informe",
    "system.label.AddressMasterTreeView":
      "Vista de Árbol Maestro de Direcciones",
    "system.label.ReportType": "Tipo de Informe",
    "system.label.ReportSubtype": "Subtipo de Informe",
    "system.label.ReportCategory": "Categoría del Informe",
    "system.label.CoreReport": "Informe Principal",
    "system.label.UserReport": "Informe del Usuario",
    "system.label.CreateReport": "Crear Informe",
    "system.label.ReportDetails": "Detalles del Informe",
    "system.label.UserReportUI": "Informe del Usuario (UI)",
    "system.label.isScheduled": "Está Programado",
    "system.label.Description": "Descripción",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "PARÁMETROS DEL INFORME",
    "system.label.AllowedParameters": "Parámetros Permitidos",
    "system.label.CreateParameter": "Crear Parámetro",
    "system.label.Parameter": "Parámetro",
    "system.label.ParameterNamePassedToPentaoh":
      "Nombre del Parámetro Pasado a Pentaoh",
    "system.label.Reset": "Restablecer",
    "system.label.EditReport": "Editar Informe",
    "system.label.DeleteReports": "Eliminar Informes",
    "system.label.ManageCodes": "Gestionar Códigos",
    "system.label.CodeModule": "Módulo de Código",
    "system.label.SystemDefined": "Definido por el Sistema",
    "system.label.CreateCode": "Crear código",
    "system.label.AddCode": "Agregar Código",
    "system.label.Module": "Módulo",
    "system.label.EditManageCodes": "Editar Gestión de Códigos",
    "system.label.CodeValue": "Valor del Código",
    "system.label.Position": "Posición",
    "system.label.Create": "Crear",
    "system.label.DeleteManageCodes": "Eliminar Gestión de Códigos",
    "system.label.ViewManageCodes": "Ver Gestión de Códigos",
    "system.label.Name": "Nombre",
    "system.label.Add": "Agregar",
    "system.label.CodeName": "Nombre del Código",
    "system.label.Submit": "Enviar",
    "system.label.isSynchronous": "Es síncrono",

    "system.label.EnterServiceDescription":
      "Ingrese la descripción del servicio",
    "system.label.Questions": "Preguntas",
    "system.label.Id": "ID",
    "system.label.QuestionType": "Tipo de pregunta",
    "system.label.QuestionText": "Texto de la pregunta",
  },

  pt: {
    "system.label.ManageMessage": "Gerenciar mensagem",
    "system.label.Role": "Função",
    "system.label.Enabled": "Ativado",
    "system.label.Enter_service_Description": "Insira a descrição do serviço",
    "system.label.Manage_Report": "Gerenciar relatório",
    "system.label.Reports": "Relatórios",
    "system.label.Create": "Criar",
    "system.label.Edit": "Editar",
    "system.label.Delete": "Excluir",
    "system.label.role": "Função",
    "system.label.clientName": "Nome do cliente",
    "system.label.assignedRoles": "Funções atribuídas",
    "system.label.editRole": "Editar função",
    "system.label.NetworkSystem": "Sistema de Rede",
    "system.label.ManageCode": "Gerenciar código",
    "system.label.ViewShift": "Ver turno",
    "system.label.HolidayManagement": "Gestão de feriados",
    "system.label.CreateHoliday": "Criar feriado",
    "system.label.EditHoliday": "Editar feriado",
    "system.label.ViewHoliday": "Ver feriado",
    "system.label.HolidayTitle": "Título do feriado",
    "system.label.Days": "Dias",
    "system.label.HolidayType": "Tipo de feriado",
    "system.label.WeeklyHolidays": "Feriados semanais",
    "system.label.SessionName": "Nome da sessão",
    "system.label.SessionDate": "Data da sessão",
    "system.label.Add": "Adicionar",
    "system.label.ViewEventActionMapping": "Ver mapeamento de ação de evento",
    "system.label.Event": "Evento",
    "system.label.Action": "Ação",
    "system.label.OrderBY": "Ordenar por",
    "system.label.ProcessParams": "Parâmetros do processo",
    "system.label.AddConfiguration": "Adicionar Configuração",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "Nome ENUM",
    "system.label.ENUM_Id": "ID ENUM",
    "system.label.ENUM_Property": "Propriedade ENUM",
    "system.label.ENUM_Value": "Valor ENUM",
    "system.label.Create_Enum": "Criar ENUM",
    "system.label.ExternalSystem": "Sistema Externo",
    "system.label.CreateDevice": "Criar dispositivo",
    "system.label.ExternalSystem": "Sistema Externo",
    "system.label.userName": "Nome de usuário",
    "system.label.firstName": "Primeiro nome",
    "system.label.lastName": "Sobrenome",
    "system.label.email": "Email",
    "system.label.officeName": "Nome do escritório",
    "system.label.action": "Ação",
    "system.label.createUser": "Criar usuário",
    "system.label.users": "Usuários",
    "system.label.View": "Ver",
    "system.label.Property": "Propriedade",
    "system.label.edit": "Editar",
    "system.label.delete": "Excluir",
    "system.label.loginName": "Nome de login",
    "system.label.entityName": "Nome da entidade",
    "system.label.roles": "Funções",
    "system.label.changePassword": "Alterar senha",
    "system.label.password": "Senha",
    "system.label.repeatPassword": "Repetir senha",
    "system.label.cancel": "Cancelar",
    "system.label.itemdescription": "Descrição do Item",
    "system.label.save": "Salvar",
    "system.label.deleteUser": "Excluir usuário",
    "system.label.areYouSure": "Tem certeza?",
    "system.label.ok": "Ok",
    "system.label.editUser": "Editar usuário",
    "system.label.availableRoles": "Funções disponíveis",
    "system.label.selectedRoles": "Funções selecionadas",
    "system.label.entity": "Entidade",
    "system.label.submit": "Enviar",
    "system.label.createUser": "Criar usuário",
    "system.label.autoGeneratePassword": "Gerar senha automaticamente",
    "system.label.reset": "Redefinir",
    "system.label.areYouSureDelete": "Tem certeza de que deseja excluir?",
    "system.label.confirm": "Confirmar",
    "system.label.createRole": "Criar Papel",
    "system.label.name": "Nome",
    "system.label.description": "Descrição",
    "system.label.permissions": "Permissões",
    "system.label.currencyConfig": "Configuração de moeda",
    "system.label.createCurrency": "Criar moeda",
    "system.label.code": "Código",
    "system.label.internationalNameCode": "Código de nome internacional",
    "system.label.decimalPlaces": "Casas decimais",
    "system.label.displaySymbol": "Símbolo de exibição",
    "system.label.viewCurrency": "Ver moeda",
    "system.label.countryCode": "Código do país",
    "system.label.countryName": "Nome do país",
    "system.label.displaySymbol": "Símbolo de exibição",
    "system.label.createCurrencyMaster": "Criar mestre de moeda",
    "system.label.currency": "Moeda",
    "system.label.nonCurrency": "Não moeda",
    "system.label.editCurrencyConfiguration": "Editar configuração de moeda",
    "system.label.deleteCurrency": "Excluir moeda",
    "system.label.deleteNonCurrency": "Excluir Não Moeda",
    "system.label.areYouSureDelete": "Tem certeza de que deseja excluir?",
    "system.label.currencyExchange": "Câmbio de moeda",
    "system.label.createExchange": "Criar câmbio",
    "system.label.id": "Id",
    "system.label.baseCurrency": "Moeda base",
    "system.label.conversionCurrency": "Moeda de conversão",
    "system.label.conversionRate": "Taxa de conversão",
    "system.label.status": "Status",
    "system.label.validFrom": "Válido de",
    "system.label.validTo": "Válido até",
    "system.label.deleteCurrencyExchange": "Excluir câmbio de moeda",
    "system.label.viewCurrencyExchange": "Ver câmbio de moeda",
    "system.label.createCurrencyExchange": "Criar câmbio de moeda",
    "system.label.editCurrencyExchange": "Editar câmbio de moeda",
    "system.label.GlobalConfiguration": "Configuração global",
    "system.label.Module": "Módulo",
    "system.label.Name": "Nome",
    "system.label.Description": "Descrição",
    "system.label.Value": "Valor",
    "system.label.Enabled": "Habilitado",
    "system.label.Flag": "Bandeira",
    "system.label.Action": "Ação",
    "system.label.EditGlobalConfiguration": "Editar configuração global",
    "system.label.PaymentGatewayConfiguration":
      "Configuração do gateway de pagamento",
    "system.label.EditPaymentGatewayConfiguration":
      "Editar configuração do gateway de pagamento",
    "system.label.Key": "Chave",
    "system.label.EnterKeyHere": "Insira a chave aqui",
    "system.label.EnterValueHere": "Insira o valor aqui",
    "system.label.Hooks": "Hooks",
    "system.label.Event": "Evento",
    "system.label.Name": "Nome",
    "system.label.Description": "Descrição",
    "system.label.Value": "Valor",
    "system.label.Enabled": "Habilitado",
    "system.label.Flag": "Bandeira",
    "system.label.Action": "Ação",
    "system.label.Process": "Processo",
    "system.label.OrderBy": "Ordenar Por",
    "system.label.PrePost": "PréPost",
    "system.label.ProcessParams": "Parâmetros do processo",
    "system.label.IsSynchronous": "É síncrono",
    "system.label.Actions": "Ações",
    "system.label.CreateEvent": "Criar evento",
    "system.label.CreateEventActionMapping":
      "Criar mapeamento de ação de evento",
    "system.label.AutoGeneratePassword": "Gerar senha automaticamente",
    "system.label.EditEventActionMapping":
      "Editar mapeamento de ação de evento",
    "system.label.ProvisioningDevice": "Dispositivo de Provisionamento",
    "system.label.ItemClass": "Classe de Item",
    "system.label.ProvisioningSystem": "Sistema de Provisionamento",
    "system.label.Create": "Criar",
    "system.label.CreateHardwarePlan": "Criar Plano de Hardware",
    "system.label.EditHardwarePlan": "Editar Plano de Hardware",
    "system.label.ProvisionCommand": "Comando de Provisionamento",
    "system.label.ProvisioningSystem": "Sistema de Provisionamento",
    "system.label.CommandName": "Nome do Comando",
    "system.label.Status": "Status",
    "system.label.Parameters": "Parâmetros",
    "system.label.CreateProvisioningMapping":
      "Criar Mapeamento de Provisionamento",
    "system.label.CommandParams": "Parâmetros do Comando",
    "system.label.ParamDefault": "Padrão do Parâmetro",
    "system.label.ParamLength": "Comprimento do Parâmetro",
    "system.label.ParamNotes": "Notas do Parâmetro",
    "system.label.ParamType": "Tipo de Parâmetro",
    "system.label.AutoGenerate": "Gerar Automaticamente",
    "system.label.ViewProvisioningMapping": "Ver Mapeamento de Provisionamento",
    "system.label.CommandParameter": "Parâmetro do Comando",
    "system.label.Edit": "Editar",
    "system.label.Delete": "Excluir",
    "system.label.DeleteProvisionCommand": "Excluir Comando de Provisionamento",
    "system.label.AreYouSure": "Você tem certeza?",
    "system.label.Ok": "Ok",
    "system.label.EditProvisioningMapping":
      "Editar Mapeamento de Provisionamento",
    "system.label.Id": "Id",
    "system.label.ParamName": "Nome do Parâmetro",
    "system.label.ProvisioningActions": "Ações de Provisionamento",
    "system.label.ProvisionType": "Tipo de Provisionamento",
    "system.label.IsEnable": "Está Habilitado",
    "system.label.NetworkSystem": "Sistema de Rede",
    "system.label.SystemCode": "Código do Sistema",
    "system.label.SystemName": "Nome do Sistema",
    "system.label.CreateNetworkSystem": "Criar Sistema de Rede",
    "system.label.GroupSupported": "Grupo Suportado",
    "system.label.EditNetworkSystem": "Editar Sistema de Rede",
    "system.label.DeleteNetworkSystem": "Excluir Sistema de Rede",
    "system.label.ManageReports": "Gerenciar Relatórios",
    "system.label.ReportName": "Nome do Relatório",
    "system.label.AddressMasterTreeView":
      "Vista em Árvore do Mestre de Endereços",
    "system.label.ReportType": "Tipo de Relatório",
    "system.label.ReportSubtype": "Subtipo de Relatório",
    "system.label.ReportCategory": "Categoria de Relatório",
    "system.label.CoreReport": "Relatório Principal",
    "system.label.UserReport": "Relatório do Usuário",
    "system.label.CreateReport": "Criar Relatório",
    "system.label.ReportDetails": "Detalhes do Relatório",
    "system.label.UserReportUI": "Relatório do Usuário (UI)",
    "system.label.isScheduled": "Está Agendado",
    "system.label.Description": "Descrição",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "PARÂMETROS DO RELATÓRIO",
    "system.label.AllowedParameters": "Parâmetros Permitidos",
    "system.label.CreateParameter": "Criar Parâmetro",
    "system.label.Parameter": "Parâmetro",
    "system.label.ParameterNamePassedToPentaoh":
      "Nome do Parâmetro Passado para o Pentaoh",
    "system.label.Reset": "Redefinir",
    "system.label.EditReport": "Editar Relatório",
    "system.label.DeleteReports": "Excluir Relatórios",
    "system.label.ManageCodes": "Gerenciar Códigos",
    "system.label.CodeModule": "Módulo de Código",
    "system.label.SystemDefined": "Definido pelo Sistema",
    "system.label.CreateCode": "Criar código",
    "system.label.AddCode": "Adicionar Código",
    "system.label.Module": "Módulo",
    "system.label.EditManageCodes": "Editar Gerenciamento de Códigos",
    "system.label.CodeValue": "Valor do Código",
    "system.label.Position": "Posição",
    "system.label.Create": "Criar",
    "system.label.DeleteManageCodes": "Excluir Gerenciamento de Códigos",
    "system.label.ViewManageCodes": "Ver Gerenciamento de Códigos",
    "system.label.Name": "Nome",
    "system.label.Add": "Adicionar",
    "system.label.CodeName": "Nome do Código",
    "system.label.Submit": "Enviar",
    "system.label.isSynchronous": "É síncrono",

    "system.label.EnterServiceDescription": "Digite a descrição do serviço",
    "system.label.Questions": "Perguntas",
    "system.label.Id": "ID",
    "system.label.QuestionType": "Tipo de pergunta",
    "system.label.QuestionText": "Texto da pergunta",
  },

  zh_CN: {
    "system.label.ManageMessage": "管理消息",
    "system.label.Role": "角色",
    "system.label.Enabled": "已启用",
    "system.label.Enter_service_Description": "输入服务描述",
    "system.label.Manage_Report": "管理报告",
    "system.label.Reports": "报告",
    "system.label.Create": "创建",
    "system.label.Edit": "编辑",
    "system.label.Delete": "删除",
    "system.label.role": "角色",
    "system.label.clientName": "客户名称",
    "system.label.assignedRoles": "分配的角色",
    "system.label.editRole": "编辑角色",
    "system.label.NetworkSystem": "网络系统",
    "system.label.ManageCode": "管理代码",
    "system.label.ViewShift": "查看班次",
    "system.label.HolidayManagement": "假期管理",
    "system.label.CreateHoliday": "创建假期",
    "system.label.EditHoliday": "编辑假期",
    "system.label.ViewHoliday": "查看假期",
    "system.label.HolidayTitle": "假期标题",
    "system.label.Days": "天数",
    "system.label.HolidayType": "假期类型",
    "system.label.WeeklyHolidays": "每周假期",
    "system.label.SessionName": "会话名称",
    "system.label.SessionDate": "会话日期",
    "system.label.Add": "添加",
    "system.label.ViewEventActionMapping": "查看事件动作映射",
    "system.label.Event": "事件",
    "system.label.Action": "操作",
    "system.label.OrderBY": "排序依据",
    "system.label.ProcessParams": "处理参数",
    "system.label.AddConfiguration": "添加配置",
    "system.label.ENUM": "枚举",
    "system.label.ENUM_Name": "枚举名称",
    "system.label.ENUM_Id": "枚举ID",
    "system.label.ENUM_Property": "枚举属性",
    "system.label.ENUM_Value": "枚举值",
    "system.label.Create_Enum": "创建枚举",
    "system.label.ExternalSystem": "外部系统",
    "system.label.CreateDevice": "创建设备",
    "system.label.ExternalSystem": "外部系统",
    "system.label.userName": "用户名",
    "system.label.firstName": "名字",
    "system.label.lastName": "姓氏",
    "system.label.email": "邮箱",
    "system.label.officeName": "办公室名称",
    "system.label.action": "操作",
    "system.label.createUser": "创建用户",
    "system.label.users": "用户",
    "system.label.View": "查看",
    "system.label.Property": "属性",
    "system.label.edit": "编辑",
    "system.label.delete": "删除",
    "system.label.loginName": "登录名",
    "system.label.entityName": "实体名称",
    "system.label.roles": "角色",
    "system.label.changePassword": "修改密码",
    "system.label.password": "密码",
    "system.label.repeatPassword": "重复密码",
    "system.label.cancel": "取消",
    "system.label.itemdescription": "项目描述",
    "system.label.save": "保存",
    "system.label.deleteUser": "删除用户",
    "system.label.areYouSure": "您确定吗？",
    "system.label.ok": "确定",
    "system.label.editUser": "编辑用户",
    "system.label.availableRoles": "可用角色",
    "system.label.selectedRoles": "已选角色",
    "system.label.entity": "实体",
    "system.label.submit": "提交",
    "system.label.createUser": "创建用户",
    "system.label.autoGeneratePassword": "自动生成密码",
    "system.label.reset": "重置",
    "system.label.areYouSureDelete": "您确定要删除吗？",
    "system.label.confirm": "确认",
    "system.label.createRole": "创建角色",
    "system.label.name": "名称",
    "system.label.description": "描述",
    "system.label.permissions": "权限",
    "system.label.currencyConfig": "货币配置",
    "system.label.createCurrency": "创建货币",
    "system.label.code": "代码",
    "system.label.internationalNameCode": "国际名称代码",
    "system.label.decimalPlaces": "小数位",
    "system.label.displaySymbol": "显示符号",
    "system.label.viewCurrency": "查看货币",
    "system.label.countryCode": "国家代码",
    "system.label.countryName": "国家名称",
    "system.label.displaySymbol": "显示符号",
    "system.label.createCurrencyMaster": "创建货币主文件",
    "system.label.currency": "货币",
    "system.label.nonCurrency": "非货币",
    "system.label.editCurrencyConfiguration": "编辑货币配置",
    "system.label.deleteCurrency": "删除货币",
    "system.label.deleteNonCurrency": "删除非货币",
    "system.label.areYouSureDelete": "您确定要删除吗？",
    "system.label.currencyExchange": "货币兑换",
    "system.label.createExchange": "创建交易",
    "system.label.id": "Id",
    "system.label.baseCurrency": "基础货币",
    "system.label.conversionCurrency": "兑换货币",
    "system.label.conversionRate": "兑换率",
    "system.label.status": "状态",
    "system.label.validFrom": "有效日期从",
    "system.label.validTo": "有效日期至",
    "system.label.deleteCurrencyExchange": "删除货币兑换",
    "system.label.viewCurrencyExchange": "查看货币兑换",
    "system.label.createCurrencyExchange": "创建货币兑换",
    "system.label.editCurrencyExchange": "编辑货币兑换",
    "system.label.GlobalConfiguration": "全局配置",
    "system.label.Module": "模块",
    "system.label.Name": "名称",
    "system.label.Description": "描述",
    "system.label.Value": "值",
    "system.label.Enabled": "启用",
    "system.label.Flag": "标志",
    "system.label.Action": "操作",
    "system.label.EditGlobalConfiguration": "编辑全局配置",
    "system.label.PaymentGatewayConfiguration": "支付网关配置",
    "system.label.EditPaymentGatewayConfiguration": "编辑支付网关配置",
    "system.label.Key": "键",
    "system.label.EnterKeyHere": "在此输入键",
    "system.label.EnterValueHere": "在此输入值",
    "system.label.Hooks": "钩子",
    "system.label.Event": "事件",
    "system.label.Name": "名称",
    "system.label.Description": "描述",
    "system.label.Value": "值",
    "system.label.Enabled": "启用",
    "system.label.Flag": "标志",
    "system.label.Action": "操作",
    "system.label.Process": "过程",
    "system.label.OrderBy": "排序依据",
    "system.label.PrePost": "前后",
    "system.label.ProcessParams": "过程参数",
    "system.label.IsSynchronous": "是否同步",
    "system.label.Actions": "操作",
    "system.label.CreateEvent": "创建事件",
    "system.label.CreateEventActionMapping": "创建事件操作映射",
    "system.label.AutoGeneratePassword": "自动生成密码",
    "system.label.EditEventActionMapping": "编辑事件操作映射",
    "system.label.ProvisioningDevice": "配置设备",
    "system.label.ItemClass": "项目类别",
    "system.label.ProvisioningSystem": "配置系统",
    "system.label.Create": "创建",
    "system.label.CreateHardwarePlan": "创建硬件计划",
    "system.label.EditHardwarePlan": "编辑硬件计划",
    "system.label.ProvisionCommand": "配置命令",
    "system.label.ProvisioningSystem": "配置系统",
    "system.label.CommandName": "命令名称",
    "system.label.Status": "状态",
    "system.label.Parameters": "参数",
    "system.label.CreateProvisioningMapping": "创建配置映射",
    "system.label.CommandParams": "命令参数",
    "system.label.ParamDefault": "参数默认",
    "system.label.ParamLength": "参数长度",
    "system.label.ParamNotes": "参数说明",
    "system.label.ParamType": "参数类型",
    "system.label.AutoGenerate": "自动生成",
    "system.label.ViewProvisioningMapping": "查看配置映射",
    "system.label.CommandParameter": "命令参数",
    "system.label.Edit": "编辑",
    "system.label.Delete": "删除",
    "system.label.DeleteProvisionCommand": "删除配置命令",
    "system.label.AreYouSure": "你确定吗？",
    "system.label.Ok": "好的",
    "system.label.EditProvisioningMapping": "编辑配置映射",
    "system.label.Id": "编号",
    "system.label.ParamName": "参数名称",
    "system.label.ProvisioningActions": "配置操作",
    "system.label.ProvisionType": "配置类型",
    "system.label.IsEnable": "是否启用",
    "system.label.NetworkSystem": "网络系统",
    "system.label.SystemCode": "系统代码",
    "system.label.SystemName": "系统名称",
    "system.label.CreateNetworkSystem": "创建网络系统",
    "system.label.GroupSupported": "支持的组",
    "system.label.EditNetworkSystem": "编辑网络系统",
    "system.label.DeleteNetworkSystem": "删除网络系统",
    "system.label.ManageReports": "管理报告",
    "system.label.ReportName": "报告名称",
    "system.label.AddressMasterTreeView": "地址主视图",
    "system.label.ReportType": "报告类型",
    "system.label.ReportSubtype": "报告子类型",
    "system.label.ReportCategory": "报告类别",
    "system.label.CoreReport": "核心报告",
    "system.label.UserReport": "用户报告",
    "system.label.CreateReport": "创建报告",
    "system.label.ReportDetails": "报告详情",
    "system.label.UserReportUI": "用户报告 (UI)",
    "system.label.isScheduled": "已计划",
    "system.label.Description": "描述",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "报告参数",
    "system.label.AllowedParameters": "允许的参数",
    "system.label.CreateParameter": "创建参数",
    "system.label.Parameter": "参数",
    "system.label.ParameterNamePassedToPentaoh": "传递给Pentaoh的参数名称",
    "system.label.Reset": "重置",
    "system.label.EditReport": "编辑报告",
    "system.label.DeleteReports": "删除报告",
    "system.label.ManageCodes": "管理代码",
    "system.label.CodeModule": "代码模块",
    "system.label.SystemDefined": "系统定义",
    "system.label.CreateCode": "創建程式碼",
    "system.label.AddCode": "添加代码",
    "system.label.Module": "模块",
    "system.label.EditManageCodes": "编辑管理代码",
    "system.label.CodeValue": "代码值",
    "system.label.Position": "位置",
    "system.label.Create": "创建",
    "system.label.DeleteManageCodes": "删除管理代码",
    "system.label.ViewManageCodes": "查看管理代码",
    "system.label.Name": "名称",
    "system.label.Add": "添加",
    "system.label.CodeName": "代码名称",
    "system.label.Submit": "提交",
    "system.label.isSynchronous": "是否同步",

    "system.label.EnterServiceDescription": "输入服务描述",
    "system.label.Questions": "问题",
    "system.label.Id": "编号",
    "system.label.QuestionType": "问题类型",
    "system.label.QuestionText": "问题文本",
  },

  hi: {
    "system.label.ManageMessage": "संदेश प्रबंधित करें",
    "system.label.Role": "भूमिका",
    "system.label.Enabled": "सक्षम",
    "system.label.Enter_service_Description": "सेवा विवरण दर्ज करें",
    "system.label.Manage_Report": "रिपोर्ट प्रबंधित करें",
    "system.label.Reports": "रिपोर्ट्स",
    "system.label.Create": "बनाएँ",
    "system.label.Edit": "संपादित करें",
    "system.label.Delete": "हटाएँ",
    "system.label.role": "भूमिका",
    "system.label.clientName": "क्लाइंट का नाम",
    "system.label.assignedRoles": "नियुक्त भूमिकाएँ",
    "system.label.editRole": "भूमिका संपादित करें",
    "system.label.NetworkSystem": "नेटवर्क सिस्टम",
    "system.label.ManageCode": "कोड प्रबंधित करें",
    "system.label.ViewShift": "शिफ्ट देखें",
    "system.label.HolidayManagement": "अवकाश प्रबंधन",
    "system.label.CreateHoliday": "अवकाश बनाएँ",
    "system.label.EditHoliday": "अवकाश संपादित करें",
    "system.label.ViewHoliday": "अवकाश देखें",
    "system.label.HolidayTitle": "अवकाश शीर्षक",
    "system.label.Days": "दिन",
    "system.label.HolidayType": "अवकाश का प्रकार",
    "system.label.WeeklyHolidays": "साप्ताहिक अवकाश",
    "system.label.SessionName": "सत्र का नाम",
    "system.label.SessionDate": "सत्र की तिथि",
    "system.label.Add": "जोड़ें",
    "system.label.ViewEventActionMapping": "इवेंट एक्शन मैपिंग देखें",
    "system.label.Event": "ईवेंट",
    "system.label.Action": "क्रिया",
    "system.label.OrderBY": "क्रमबद्ध करें",
    "system.label.ProcessParams": "प्रक्रिया पैरामीटर",
    "system.label.AddConfiguration": "कॉन्फ़िगरेशन जोड़ें",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "ENUM नाम",
    "system.label.ENUM_Id": "ENUM आईडी",
    "system.label.ENUM_Property": "ENUM गुण",
    "system.label.ENUM_Value": "ENUM मान",
    "system.label.Create_Enum": "ENUM बनाएँ",
    "system.label.ExternalSystem": "बाहरी प्रणाली",
    "system.label.CreateDevice": "डिवाइस बनाएं",
    "system.label.ExternalSystem": "बाहरी प्रणाली",
    "system.label.userName": "उपयोगकर्ता नाम",
    "system.label.firstName": "पहला नाम",
    "system.label.lastName": "उपनाम",
    "system.label.email": "ईमेल",
    "system.label.officeName": "कार्यालय का नाम",
    "system.label.action": "कार्रवाई",
    "system.label.createUser": "उपयोगकर्ता बनाएं",
    "system.label.users": "उपयोगकर्ता",
    "system.label.View": "देखें",
    "system.label.Property": "संपत्ति",
    "system.label.edit": "संपादित करें",
    "system.label.delete": "हटाएं",
    "system.label.loginName": "लॉगिन नाम",
    "system.label.entityName": "संस्थान का नाम",
    "system.label.roles": "भूमिकाएँ",
    "system.label.changePassword": "पासवर्ड बदलें",
    "system.label.password": "पासवर्ड",
    "system.label.repeatPassword": "पासवर्ड दोहराएं",
    "system.label.cancel": "रद्द करें",
    "system.label.itemdescription": "आइटम विवरण",
    "system.label.save": "सहेजें",
    "system.label.deleteUser": "उपयोगकर्ता हटाएं",
    "system.label.areYouSure": "क्या आप सुनिश्चित हैं?",
    "system.label.ok": "ठीक है",
    "system.label.editUser": "उपयोगकर्ता संपादित करें",
    "system.label.availableRoles": "उपलब्ध भूमिकाएँ",
    "system.label.selectedRoles": "चयनित भूमिकाएँ",
    "system.label.entity": "संस्था",
    "system.label.submit": "प्रस्तुत करें",
    "system.label.createUser": "उपयोगकर्ता बनाएं",
    "system.label.autoGeneratePassword": "स्वचालित रूप से पासवर्ड बनाएं",
    "system.label.reset": "रीसेट",
    "system.label.areYouSureDelete": "क्या आप वाकई मिटाना चाहते हैं?",
    "system.label.confirm": "पुष्टि करें",
    "system.label.createRole": "रोल बनाएं",
    "system.label.name": "नाम",
    "system.label.description": "विवरण",
    "system.label.permissions": "अनुमतियाँ",
    "system.label.currencyConfig": "मुद्रा कॉन्फ़िगरेशन",
    "system.label.createCurrency": "मुद्रा बनाएँ",
    "system.label.code": "कोड",
    "system.label.internationalNameCode": "अंतरराष्ट्रीय नाम कोड",
    "system.label.decimalPlaces": "दशमलव स्थान",
    "system.label.displaySymbol": "प्रदर्शन सिम्बल",
    "system.label.viewCurrency": "मुद्रा देखें",
    "system.label.countryCode": "देश कोड",
    "system.label.countryName": "देश का नाम",
    "system.label.displaySymbol": "प्रदर्शन सिम्बल",
    "system.label.createCurrencyMaster": "मुद्रा मास्टर बनाएं",
    "system.label.currency": "मुद्रा",
    "system.label.nonCurrency": "गैर-मुद्रा",
    "system.label.editCurrencyConfiguration":
      "मुद्रा कॉन्फ़िगरेशन संपादित करें",
    "system.label.deleteCurrency": "मुद्रा हटाएं",
    "system.label.deleteNonCurrency": "गैर-मुद्रा हटाएं",
    "system.label.areYouSureDelete": "क्या आप वाकई हटाना चाहते हैं?",
    "system.label.currencyExchange": "मुद्रा विनिमय",
    "system.label.createExchange": "विनिमय बनाएं",
    "system.label.id": "Id",
    "system.label.baseCurrency": "मूल मुद्रा",
    "system.label.conversionCurrency": "परिवर्तन मुद्रा",
    "system.label.conversionRate": "परिवर्तन दर",
    "system.label.status": "स्थिति",
    "system.label.validFrom": "से वैध",
    "system.label.validTo": "तक वैध",
    "system.label.deleteCurrencyExchange": "मुद्रा विनिमय हटाएं",
    "system.label.viewCurrencyExchange": "मुद्रा विनिमय देखें",
    "system.label.createCurrencyExchange": "मुद्रा विनिमय बनाएं",
    "system.label.editCurrencyExchange": "मुद्रा विनिमय संपादित करें",
    "system.label.GlobalConfiguration": "वैश्विक कॉन्फ़िगरेशन",
    "system.label.Module": "मॉड्यूल",
    "system.label.Name": "नाम",
    "system.label.Description": "विवरण",
    "system.label.Value": "मूल्य",
    "system.label.Enabled": "सक्षम",
    "system.label.Flag": "झंडा",
    "system.label.Action": "कार्य",
    "system.label.EditGlobalConfiguration": "वैश्विक कॉन्फ़िगरेशन संपादित करें",
    "system.label.PaymentGatewayConfiguration": "भुगतान गेटवे कॉन्फ़िगरेशन",
    "system.label.EditPaymentGatewayConfiguration":
      "भुगतान गेटवे कॉन्फ़िगरेशन संपादित करें",
    "system.label.Key": "कुंजी",
    "system.label.EnterKeyHere": "कुंजी यहाँ दर्ज करें",
    "system.label.EnterValueHere": "मूल्य यहाँ दर्ज करें",
    "system.label.Hooks": "हुक",
    "system.label.Event": "घटना",
    "system.label.Name": "नाम",
    "system.label.Description": "विवरण",
    "system.label.Value": "मूल्य",
    "system.label.Enabled": "सक्रिय",
    "system.label.Flag": "झंडा",
    "system.label.Action": "क्रिया",
    "system.label.Process": "प्रक्रिया",
    "system.label.OrderBy": "द्वारा क्रमबद्ध करें",
    "system.label.PrePost": "पूर्व पोस्ट",
    "system.label.ProcessParams": "प्रक्रिया पैरामीटर",
    "system.label.IsSynchronous": "क्या समकालिक है",
    "system.label.Actions": "क्रियाएँ",
    "system.label.CreateEvent": "घटना बनाएं",
    "system.label.CreateEventActionMapping": "ईवेंट एक्शन मैपिंग बनाएं",
    "system.label.AutoGeneratePassword": "स्वचालित पासवर्ड जनरेट करें",
    "system.label.EditEventActionMapping": "ईवेंट एक्शन मैपिंग संपादित करें",
    "system.label.ProvisioningDevice": "प्रोविजनिंग डिवाइस",
    "system.label.ItemClass": "आइटम क्लास",
    "system.label.ProvisioningSystem": "प्रोविजनिंग सिस्टम",
    "system.label.Create": "बनाएं",
    "system.label.CreateHardwarePlan": "हार्डवेयर योजना बनाएं",
    "system.label.EditHardwarePlan": "हार्डवेयर योजना संपादित करें",
    "system.label.ProvisionCommand": "प्रोविजनिंग कमांड",
    "system.label.ProvisioningSystem": "प्रोविजनिंग सिस्टम",
    "system.label.CommandName": "कमान्ड नाम",
    "system.label.Status": "स्थिति",
    "system.label.Parameters": "पैरामीटर",
    "system.label.CreateProvisioningMapping": "प्रोविजनिंग मैपिंग बनाएं",
    "system.label.CommandParams": "कमान्ड पैरामीटर",
    "system.label.ParamDefault": "पैरामीटर डिफॉल्ट",
    "system.label.ParamLength": "पैरामीटर की लंबाई",
    "system.label.ParamNotes": "पैरामीटर नोट्स",
    "system.label.ParamType": "पैरामीटर प्रकार",
    "system.label.AutoGenerate": "स्वचालित उत्पन्न करें",
    "system.label.ViewProvisioningMapping": "प्रोविजनिंग मैपिंग देखें",
    "system.label.CommandParameter": "कमान्ड पैरामीटर",
    "system.label.Edit": "संपादित करें",
    "system.label.Delete": "हटाएं",
    "system.label.DeleteProvisionCommand": "प्रोविजनिंग कमांड हटाएं",
    "system.label.AreYouSure": "क्या आपको यकीन है?",
    "system.label.Ok": "ठीक",
    "system.label.EditProvisioningMapping": "प्रोविजनिंग मैपिंग संपादित करें",
    "system.label.Id": "आईडी",
    "system.label.ParamName": "पैराम का नाम",
    "system.label.ProvisioningActions": "प्रावधान क्रियाएँ",
    "system.label.ProvisionType": "प्रावधान प्रकार",
    "system.label.IsEnable": "सक्षम है",
    "system.label.NetworkSystem": "नेटवर्क सिस्टम",
    "system.label.SystemCode": "सिस्टम कोड",
    "system.label.SystemName": "सिस्टम का नाम",
    "system.label.CreateNetworkSystem": "नेटवर्क सिस्टम बनाएं",
    "system.label.GroupSupported": "समूह समर्थित",
    "system.label.EditNetworkSystem": "नेटवर्क सिस्टम संपादित करें",
    "system.label.DeleteNetworkSystem": "नेटवर्क सिस्टम हटाएं",
    "system.label.ManageReports": "रिपोर्ट प्रबंधित करें",
    "system.label.ReportName": "रिपोर्ट का नाम",
    "system.label.AddressMasterTreeView": "पता मास्टर ट्री दृश्य",
    "system.label.ReportType": "रिपोर्ट प्रकार",
    "system.label.ReportSubtype": "रिपोर्ट उपप्रकार",
    "system.label.ReportCategory": "रिपोर्ट श्रेणी",
    "system.label.CoreReport": "मुख्य रिपोर्ट",
    "system.label.UserReport": "उपयोगकर्ता रिपोर्ट",
    "system.label.CreateReport": "रिपोर्ट बनाएं",
    "system.label.ReportDetails": "रिपोर्ट विवरण",
    "system.label.UserReportUI": "उपयोगकर्ता रिपोर्ट (UI)",
    "system.label.isScheduled": "निर्धारित है",
    "system.label.Description": "विवरण",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "रिपोर्ट पैरामीटर",
    "system.label.AllowedParameters": "अनुमत पैरामीटर",
    "system.label.CreateParameter": "पैरामीटर बनाएं",
    "system.label.Parameter": "पैरामीटर",
    "system.label.ParameterNamePassedToPentaoh":
      "Pentaoh को पास किया गया पैरामीटर नाम",
    "system.label.Reset": "रीसेट करें",
    "system.label.EditReport": "रिपोर्ट संपादित करें",
    "system.label.DeleteReports": "रिपोर्ट्स को हटाएं",
    "system.label.ManageCodes": "कोड प्रबंधित करें",
    "system.label.CodeModule": "कोड मॉड्यूल",
    "system.label.SystemDefined": "सिस्टम द्वारा परिभाषित",
    "system.label.CreateCode": "कोड बनाएं",
    "system.label.AddCode": "कोड जोड़ें",
    "system.label.Module": "मॉड्यूल",
    "system.label.EditManageCodes": "कोड प्रबंधन संपादित करें",
    "system.label.CodeValue": "कोड मूल्य",
    "system.label.Position": "स्थिति",
    "system.label.Create": "बनाएं",
    "system.label.DeleteManageCodes": "कोड प्रबंधन हटाएं",
    "system.label.ViewManageCodes": "कोड प्रबंधन देखें",
    "system.label.Name": "नाम",
    "system.label.Add": "जोड़ें",
    "system.label.CodeName": "कोड नाम",
    "system.label.Submit": "प्रस्तुत करें",
    "system.label.isSynchronous": "समकालिक है",

    "system.label.EnterServiceDescription": "सेवा का विवरण दर्ज करें",
    "system.label.Questions": "प्रश्न",
    "system.label.Id": "पहचान",
    "system.label.QuestionType": "प्रश्न प्रकार",
    "system.label.QuestionText": "प्रश्न पाठ",
  },

  ka: {
    "system.label.ManageMessage": "მესიჯის მართვა",
    "system.label.Role": "როლი",
    "system.label.Enabled": "ჩართულია",
    "system.label.Enter_service_Description": "შეიყვანეთ სერვისის აღწერა",
    "system.label.Manage_Report": "ანგარიშის მართვა",
    "system.label.Reports": "ანგარიშები",
    "system.label.Create": "შექმნა",
    "system.label.Edit": "რედაქტირება",
    "system.label.Delete": "წაშლა",
    "system.label.role": "როლი",
    "system.label.clientName": "კლიენტის სახელი",
    "system.label.assignedRoles": "დანიშნული როლები",
    "system.label.editRole": "როლის რედაქტირება",
    "system.label.NetworkSystem": "ქსელის სისტემა",
    "system.label.ManageCode": "კოდის მართვა",
    "system.label.ViewShift": "ცვლის ნახვა",
    "system.label.HolidayManagement": "დღესასწაულების მართვა",
    "system.label.CreateHoliday": "დღესასწაულის შექმნა",
    "system.label.EditHoliday": "დღესასწაულის რედაქტირება",
    "system.label.ViewHoliday": "დღესასწაულის ნახვა",
    "system.label.HolidayTitle": "დღესასწაულის სათაური",
    "system.label.Days": "დღეები",
    "system.label.HolidayType": "დღესასწაულის ტიპი",
    "system.label.WeeklyHolidays": "კვირეული არდადეგები",
    "system.label.SessionName": "სესიის სახელი",
    "system.label.SessionDate": "სესიის თარიღი",
    "system.label.Add": "დამატება",
    "system.label.ViewEventActionMapping": "ივენთის ქმედების მიბმის ნახვა",
    "system.label.Event": "მოვლენა",
    "system.label.Action": "ქმედება",
    "system.label.OrderBY": "დალაგება",
    "system.label.ProcessParams": "დამუშავების პარამეტრები",
    "system.label.AddConfiguration": "კონფიგურაციის დამატება",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "ENUM სახელი",
    "system.label.ENUM_Id": "ENUM ID",
    "system.label.ENUM_Property": "ENUM თვისება",
    "system.label.ENUM_Value": "ENUM მნიშვნელობა",
    "system.label.Create_Enum": "ENUM-ის შექმნა",
    "system.label.ExternalSystem": "გარე სისტემა",
    "system.label.CreateDevice": "მოწყობილობის შექმნა",
    "system.label.ExternalSystem": "გარე სისტემა",
    "system.label.userName": "მომხმარებლის სახელი",
    "system.label.firstName": "სახელი",
    "system.label.lastName": "გვარი",
    "system.label.email": "ელ. ფოსტა",
    "system.label.officeName": "ოფისის სახელი",
    "system.label.action": "ქმედება",
    "system.label.createUser": "მომხმარებლის შექმნა",
    "system.label.users": "მომხმარებელი",
    "system.label.View": "ნახვა",
    "system.label.Property": "ქონება",
    "system.label.edit": "რედაქტირება",
    "system.label.delete": "წაშლა",
    "system.label.loginName": "შესვლის სახელი",
    "system.label.entityName": "ენთიტეტის სახელი",
    "system.label.roles": "როლები",
    "system.label.changePassword": "პაროლის შეცვლა",
    "system.label.password": "პაროლი",
    "system.label.repeatPassword": "პაროლის გამეორება",
    "system.label.cancel": "გაუქმება",
    "system.label.itemdescription": "ნივთის აღწერა",
    "system.label.save": "შენახვა",
    "system.label.deleteUser": "მომხმარებელის წაშლა",
    "system.label.areYouSure": "ნამდვილად გსურთ?",
    "system.label.ok": "კარგი",
    "system.label.editUser": "მომხმარებლის რედაქტირება",
    "system.label.availableRoles": "ხელმისაწვდომი როლები",
    "system.label.selectedRoles": "არჩეული როლები",
    "system.label.entity": "ენთიტეტი",
    "system.label.submit": "წარდგენა",
    "system.label.createUser": "მომხმარებელის შექმნა",
    "system.label.autoGeneratePassword": "პაროლის ავტომატური გენერაცია",
    "system.label.reset": "გადატვირთვა",
    "system.label.areYouSureDelete": "ნამდვილად გსურთ წაშლა?",
    "system.label.confirm": "დადასტურება",
    "system.label.createRole": "როლის შექმნა",
    "system.label.name": "სახელი",
    "system.label.description": "აღწერა",
    "system.label.permissions": "უფლებები",
    "system.label.currencyConfig": "ვალუტის კონფიგურაცია",
    "system.label.createCurrency": "ვალუტის შექმნა",
    "system.label.code": "კოდი",
    "system.label.internationalNameCode": "საერთაშორისო სახელწოდების კოდი",
    "system.label.decimalPlaces": "დეციმალური ადგილები",
    "system.label.displaySymbol": "სიმბოლოს ჩვენება",
    "system.label.viewCurrency": "ვალუტის ნახვა",
    "system.label.countryCode": "ქვეყნის კოდი",
    "system.label.countryName": "ქვეყნის სახელი",
    "system.label.displaySymbol": "სიმბოლოს ჩვენება",
    "system.label.createCurrencyMaster": "ვალუტის მასტერის შექმნა",
    "system.label.currency": "ვალუტა",
    "system.label.nonCurrency": "არა-ვალუტა",
    "system.label.editCurrencyConfiguration":
      "ვალუტის კონფიგურაციის რედაქტირება",
    "system.label.deleteCurrency": "ვალუტა წაშლა",
    "system.label.deleteNonCurrency": "არავალუტურის წაშლა",
    "system.label.areYouSureDelete": "ნამდვილად გსურთ წაშლა?",
    "system.label.currencyExchange": "ვალუტის გაცვლა",
    "system.label.createExchange": "შექმნა გაცვლა",
    "system.label.id": "Id",
    "system.label.baseCurrency": "საბაზო ვალუტა",
    "system.label.conversionCurrency": "კონვერტაციის ვალუტა",
    "system.label.conversionRate": "კონვერტაციის კურსი",
    "system.label.status": "სტატუსი",
    "system.label.validFrom": "მოქმედებს დასაწყისი",
    "system.label.validTo": "მოქმედებს სასრული",
    "system.label.deleteCurrencyExchange": "ვალუტის გაცვლა წაშლა",
    "system.label.viewCurrencyExchange": "ვალუტის გაცვლის ნახვა",
    "system.label.createCurrencyExchange": "ვალუტის გაცვლის შექმნა",
    "system.label.editCurrencyExchange": "ვალუტის გაცვლის რედაქტირება",
    "system.label.GlobalConfiguration": "გლობალური კონფიგურაცია",
    "system.label.Module": "მოდული",
    "system.label.Name": "სახელი",
    "system.label.Description": "აღწერა",
    "system.label.Value": "მნიშვნელობა",
    "system.label.Enabled": "ჩართულია",
    "system.label.Flag": "დროშა",
    "system.label.Action": "მოქმედება",
    "system.label.EditGlobalConfiguration":
      "გლობალური კონფიგურაციის რედაქტირება",
    "system.label.PaymentGatewayConfiguration":
      "გადახდის კარიბჭის კონფიგურაცია",
    "system.label.EditPaymentGatewayConfiguration":
      "გადახდის კარიბჭის კონფიგურაციის რედაქტირება",
    "system.label.Key": "გასაღები",
    "system.label.EnterKeyHere": "გახსენით გასაღები აქ",
    "system.label.EnterValueHere": "გახსენით მნიშვნელობა აქ",
    "system.label.Hooks": "Hooks",
    "system.label.Event": "მოვლენა",
    "system.label.Name": "სახელი",
    "system.label.Description": "აღწერა",
    "system.label.Value": "მნიშვნელობა",
    "system.label.Enabled": "ჩართულია",
    "system.label.Flag": "დროშა",
    "system.label.Action": "მოქმედება",
    "system.label.Process": "პროცესი",
    "system.label.OrderBy": "დაალაგე",
    "system.label.PrePost": "წინასწარი პოსტი",
    "system.label.ProcessParams": "პროცესის პარამეტრები",
    "system.label.IsSynchronous": "არის სინქრონული",
    "system.label.Actions": "მოქმედებები",
    "system.label.CreateEvent": "მოვლენის შექმნა",
    "system.label.CreateEventActionMapping":
      "მოვლენის მოქმედების მეპინგის შექმნა",
    "system.label.AutoGeneratePassword": "პაროლის ავტომატური შექმნა",
    "system.label.EditEventActionMapping":
      "მოვლენის მოქმედების მეპინგის რედაქტირება",
    "system.label.ProvisioningDevice": "პროვიზიონირების მოწყობილობა",
    "system.label.ItemClass": "ერთეულის კლასი",
    "system.label.ProvisioningSystem": "პროვიზიონირების სისტემა",
    "system.label.Create": "შექმნა",
    "system.label.CreateHardwarePlan": "მოწყობილობის გეგმის შექმნა",
    "system.label.EditHardwarePlan": "მოწყობილობის გეგმის რედაქტირება",
    "system.label.ProvisionCommand": "პროვიზიონირების ბრძანება",
    "system.label.ProvisioningSystem": "პროვიზიონირების სისტემა",
    "system.label.CommandName": "ბრძანების სახელი",
    "system.label.Status": "სტატუსი",
    "system.label.Parameters": "პარამეტრები",
    "system.label.CreateProvisioningMapping": "პროვიზიონირების მეპინგის შექმნა",
    "system.label.CommandParams": "ბრძანების პარამეტრები",
    "system.label.ParamDefault": "პარამეტრის ნაგულისხმევი მნიშვნელობა",
    "system.label.ParamLength": "პარამეტრის სიგრძე",
    "system.label.ParamNotes": "პარამეტრის შენიშვნები",
    "system.label.ParamType": "პარამეტრის ტიპი",
    "system.label.AutoGenerate": "ავტომატურად გენერირება",
    "system.label.ViewProvisioningMapping": "პროვიზიონირების მეპინგის ნახვა",
    "system.label.CommandParameter": "ბრძანების პარამეტრი",
    "system.label.Edit": "რედაქტირება",
    "system.label.Delete": "წაშლა",
    "system.label.DeleteProvisionCommand": "პროვიზიონირების ბრძანების წაშლა",
    "system.label.AreYouSure": "დარწმუნებული ხართ?",
    "system.label.Ok": "კარგი",
    "system.label.EditProvisioningMapping":
      "პროვიზიონირების მეპინგის რედაქტირება",
    "system.label.Id": "ID",
    "system.label.ParamName": "პარამეტრის სახელი",
    "system.label.ProvisioningActions": "პროვიზიონირების მოქმედებები",
    "system.label.ProvisionType": "პროვიზიონირების ტიპი",
    "system.label.IsEnable": "ჩართულია",
    "system.label.NetworkSystem": "ქსელური სისტემა",
    "system.label.SystemCode": "სისტემის კოდი",
    "system.label.SystemName": "სისტემის სახელი",
    "system.label.CreateNetworkSystem": "ქსელური სისტემის შექმნა",
    "system.label.GroupSupported": "ჯგუფის მხარდაჭერა",
    "system.label.EditNetworkSystem": "ქსელური სისტემის რედაქტირება",
    "system.label.DeleteNetworkSystem": "ქსელური სისტემის წაშლა",
    "system.label.ManageReports": "ანგარიშების მართვა",
    "system.label.ReportName": "ანგარიშის სახელი",
    "system.label.AddressMasterTreeView": "მისამართების ძირითადი ხის ხედვა",
    "system.label.ReportType": "ანგარიშის ტიპი",
    "system.label.ReportSubtype": "ანგარიშის ქვეტიპი",
    "system.label.ReportCategory": "ანგარიშის კატეგორია",
    "system.label.CoreReport": "ძირითადი ანგარიში",
    "system.label.UserReport": "მომხმარებლის ანგარიში",
    "system.label.CreateReport": "ანგარიშის შექმნა",
    "system.label.ReportDetails": "ანგარიშის დეტალები",
    "system.label.UserReportUI": "მომხმარებლის ანგარიში (UI)",
    "system.label.isScheduled": "გეგმაშია",
    "system.label.Description": "აღწერა",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "ანგარიშის პარამეტრები",
    "system.label.AllowedParameters": "ნებადართული პარამეტრები",
    "system.label.CreateParameter": "პარამეტრის შექმნა",
    "system.label.Parameter": "პარამეტრი",
    "system.label.ParameterNamePassedToPentaoh":
      "პარამეტრის სახელი, რომელიც გადაეცა Pentaoh-ს",
    "system.label.Reset": "გადატვირთვა",
    "system.label.EditReport": "ანგარიშის რედაქტირება",
    "system.label.DeleteReports": "ანგარიშების წაშლა",
    "system.label.ManageCodes": "კოდების მართვა",
    "system.label.CodeModule": "კოდის მოდული",
    "system.label.SystemDefined": "სისტემის მიერ განსაზღვრული",
    "system.label.CreateCode": "შექმენით კოდი",
    "system.label.AddCode": "კოდის დამატება",
    "system.label.Module": "მოდული",
    "system.label.EditManageCodes": "კოდების მართვის რედაქტირება",
    "system.label.CodeValue": "კოდის მნიშვნელობა",
    "system.label.Position": "პოზიცია",
    "system.label.Create": "შექმნა",
    "system.label.DeleteManageCodes": "კოდების მართვის წაშლა",
    "system.label.ViewManageCodes": "კოდების მართვის ნახვა",
    "system.label.Name": "სახელი",
    "system.label.Add": "დამატება",
    "system.label.CodeName": "კოდის სახელი",
    "system.label.Submit": "გაგზავნა",
    "system.label.isSynchronous": "სინქრონულია",

    "system.label.EnterServiceDescription": "შეიყვანეთ მომსახურების აღწერა",
    "system.label.Questions": "შეკითხვები",
    "system.label.Id": "იდენტიფიკატორი",
    "system.label.QuestionType": "შეკითხვის ტიპი",
    "system.label.QuestionText": "შეკითხვის ტექსტი",
  },

  lo: {
    "system.label.ManageMessage": "ຈັດການຂໍ້ຄວາມ",
    "system.label.Role": "ບົດບາດ",
    "system.label.Enabled": "ເປີດໃຊ້ງານ",
    "system.label.Enter_service_Description": "ໃສ່ລາຍລະອຽດການບໍລິການ",
    "system.label.Manage_Report": "ຈັດການບົດລາຍງານ",
    "system.label.Reports": "ບົດລາຍງານ",
    "system.label.Create": "ສ້າງ",
    "system.label.Edit": "ແກ້ໄຂ",
    "system.label.Delete": "ລຶບ",
    "system.label.role": "ບົດບາດ",
    "system.label.clientName": "ຊື່ລູກຄ້າ",
    "system.label.assignedRoles": "ບົດບາດທີ່ໄດ້ຮັບມອບໝາຍ",
    "system.label.editRole": "ແກ້ໄຂບົດບາດ",
    "system.label.NetworkSystem": "ລະບົບເຄືອຂ່າຍ",
    "system.label.ManageCode": "ຈັດການລະຫັດ",
    "system.label.ViewShift": "ເບິ່ງກະຈອງ",
    "system.label.HolidayManagement": "ການຄຸ້ມຄອງວັນພັກ",
    "system.label.CreateHoliday": "ສ້າງວັນພັກ",
    "system.label.EditHoliday": "ແກ້ໄຂວັນພັກ",
    "system.label.ViewHoliday": "ເບິ່ງວັນພັກ",
    "system.label.HolidayTitle": "ຫົວຂໍ້ວັນພັກ",
    "system.label.Days": "ມື້",
    "system.label.HolidayType": "ປະເພດວັນພັກ",
    "system.label.WeeklyHolidays": "ວັນພັກປະຈຳສັບດາ",
    "system.label.SessionName": "ຊື່ເຊດຊັນ",
    "system.label.SessionDate": "ວັນທີເຊດຊັນ",
    "system.label.Add": "ເພີ່ມ",
    "system.label.ViewEventActionMapping": "ເບິ່ງການແມບກັບການປະຕິບັດເຫດການ",
    "system.label.Event": "ເຫດການ",
    "system.label.Action": "ການປະຕິບັດ",
    "system.label.OrderBY": "ຈັດລຽງຕາມ",
    "system.label.ProcessParams": "參ພາລາມິເຕີການປະຕິບັດ",
    "system.label.AddConfiguration": "ເພີ່ມການກໍ່ຕັ້ງ",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "ຊື່ ENUM",
    "system.label.ENUM_Id": "ID ENUM",
    "system.label.ENUM_Property": "ຄຸນສົມບັດ ENUM",
    "system.label.ENUM_Value": "ຄ່າ ENUM",
    "system.label.Create_Enum": "ສ້າງ ENUM",
    "system.label.ExternalSystem": "ລະບົບພາຍນອກ",
    "system.label.CreateDevice": "ສ້າງເຄື່ອງມື",
    "system.label.ExternalSystem": "ລະບົບພາຍນອກ",
    "system.label.userName": "ຊື່ຜູ້ໃຊ້",
    "system.label.firstName": "ຊື່ທີ່ສຸດ",
    "system.label.lastName": "ນາມສະກຸນ",
    "system.label.email": "ອີເມວ",
    "system.label.officeName": "ຊື່ຫ້ອງການ",
    "system.label.action": "ການຄຸ້ມຄອງ",
    "system.label.createUser": "ສ້າງຜູ້ໃຊ້",
    "system.label.users": "ຜູ້ໃຊ້",
    "system.label.View": "ເບິ່ງ",
    "system.label.Property": "ສິນຄ",
    "system.label.edit": "ແກ້ໄຂ",
    "system.label.delete": "ລຶບ",
    "system.label.loginName": "ຊື່ການເຂົ້າລະບົບ",
    "system.label.entityName": "ຊັ້ນສະຫຼຸບ",
    "system.label.roles": "ບົດບາດ",
    "system.label.changePassword": "ແກ້ໄຂລະຫັດຜ່ານ",
    "system.label.password": "ລະຫັດຜ່ານ",
    "system.label.repeatPassword": "ລະຫັດຜ່ານຄືນ",
    "system.label.cancel": "ຍົກເລີກ",
    "system.label.itemdescription": "ຄະແນນສິນຄ້າ",
    "system.label.save": "ບັນທືກ",
    "system.label.deleteUser": "ລຶບຜູ້ໃຊ້",
    "system.label.areYouSure": "ທ່ານແມ່ນແທ້ຈິງບໍ?",
    "system.label.ok": "ຕົກ​ລົງ",
    "system.label.editUser": "ແກ້ໄຂຜູ້ໃຊ້",
    "system.label.availableRoles": "ບົດບາດທີ່ມີຢູ່",
    "system.label.selectedRoles": "ບົດບາດທີ່ເລືອກ",
    "system.label.entity": "ຜູ້ໃຊ້",
    "system.label.submit": "ສົ່ງ",
    "system.label.createUser": "ສ້າງຜູ້ໃຊ້",
    "system.label.autoGeneratePassword": "ສ້າງລະຫັດຜ່ານໃຫ້ອັດຕະໂນມັດ",
    "system.label.reset": "ປັບລົບ",
    "system.label.areYouSureDelete": "ທ່ານເປັນຕ້ອງການລຶບແທ້ຈິງບໍ?",
    "system.label.confirm": "ຢືນຢັນ",
    "system.label.createRole": "ສ້າງບົດບາດ",
    "system.label.name": "ຊື່",
    "system.label.description": "ລາຍລະອຽດ",
    "system.label.permissions": "ສິດທິ",
    "system.label.currencyConfig": "ການຕັ້ງຄ່າເງິນ",
    "system.label.createCurrency": "ສ້າງເງິນ",
    "system.label.code": "ລະຫັດ",
    "system.label.internationalNameCode": "ລະຫັດຊື່ມືຖືຂອງມືຖື",
    "system.label.decimalPlaces": "ສະຖານະສູງ",
    "system.label.displaySymbol": "ສະຕັອກສັນຍາລັກ",
    "system.label.viewCurrency": "ເບິ່ງເງິນ",
    "system.label.countryCode": "ລະຫັດປະເທດ",
    "system.label.countryName": "ຊື່ປະເທດ",
    "system.label.displaySymbol": "ສະຕັອກສັນຍາລັກ",
    "system.label.createCurrencyMaster": "ສ້າງຄວາມຮູ້ຂອງເງິນ",
    "system.label.currency": "ເງິນ",
    "system.label.nonCurrency": "ບໍ່ເງິນ",
    "system.label.editCurrencyConfiguration": "ແກ້ໄຂການຕັ້ງຄ່າເງິນ",
    "system.label.deleteCurrency": "ລຶບເງິນ",
    "system.label.deleteNonCurrency": "ລຶບທີ່ບໍ່ແມ່ນເງິນຕາ",
    "system.label.areYouSureDelete": "ທ່ານເປັນຕ້ອງການລຶບແທ້ຈິງບໍ?",
    "system.label.currencyExchange": "ການສະແດງຄ່າເງິນ",
    "system.label.createExchange": "ສ້າງການສະແດງ",
    "system.label.id": "Id",
    "system.label.baseCurrency": "ສະກຸນການສັ່ງຊື້",
    "system.label.conversionCurrency": "ສະກຸນການປະຕິເສດ",
    "system.label.conversionRate": "ອັດຕາຄ່າປະຕິເສດ",
    "system.label.status": "ສະຖານະ",
    "system.label.validFrom": "ອັດຕາຈາກ",
    "system.label.validTo": "ອັດຕາເຖິງ",
    "system.label.deleteCurrencyExchange": "ລຶບການສະແດງຄ່າເງິນ",
    "system.label.viewCurrencyExchange": "ເບິ່ງການສະແດງຄ່າເງິນ",
    "system.label.createCurrencyExchange": "ສ້າງການສະແດງຄ່າເງິນ",
    "system.label.editCurrencyExchange": "ແກ້ໄຂການສະແດງຄ່າເງິນ",
    "system.label.GlobalConfiguration": "ການຕັ້ງຄ່າທົ່ວໂລກ",
    "system.label.Module": "ໂມດູນ",
    "system.label.Name": "ຊື່",
    "system.label.Description": "ຄຳອະທິບາຍ",
    "system.label.Value": "ຄ່າ",
    "system.label.Enabled": "ເປີດໃຊ້",
    "system.label.Flag": "ທຸງ",
    "system.label.Action": "ການປະຕິບັດ",
    "system.label.EditGlobalConfiguration": "ແກ້ໄຂການຕັ້ງຄ່າທົ່ວໂລກ",
    "system.label.PaymentGatewayConfiguration": "ການຕັ້ງຄ່າປະຕູການຊຳລະເງິນ",
    "system.label.EditPaymentGatewayConfiguration":
      "ແກ້ໄຂການຕັ້ງຄ່າປະຕູການຊຳລະເງິນ",
    "system.label.Key": "ຄີ",
    "system.label.EnterKeyHere": "ໃສ່ຄີທີ່ນີ້",
    "system.label.EnterValueHere": "ໃສ່ຄ່າທີ່ນີ້",
    "system.label.Hooks": "ເຕົາຕິດ",
    "system.label.Event": "ເຫດການ",
    "system.label.Name": "ຊື່",
    "system.label.Description": "ຄຳອະທິບາຍ",
    "system.label.Value": "ຄ່າ",
    "system.label.Enabled": "ເປີດໃຊ້",
    "system.label.Flag": "ທຸງ",
    "system.label.Action": "ການປະຕິບັດ",
    "system.label.Process": "ຂະບວນການ",
    "system.label.OrderBy": "ສັ່ງໂດຍ",
    "system.label.PrePost": "ກ່ອນແລະຫຼັງ",
    "system.label.ProcessParams": "ພາລາມິເຕີຂະບວນການ",
    "system.label.IsSynchronous": "ແມ່ນການປະສານກັນ",
    "system.label.Actions": "ການປະຕິບັດ",
    "system.label.CreateEvent": "ສ້າງເຫດການ",
    "system.label.CreateEventActionMapping": "ສ້າງເຫດການທີ່ແມ່ນການປະຕິບັດ",
    "system.label.AutoGeneratePassword": "ສ້າງລະຫັດຜ່ານໂດຍອັດຕະໂນມັດ",
    "system.label.EditEventActionMapping": "ແກ້ໄຂການແມ່ນການປະຕິບັດ",
    "system.label.ProvisioningDevice": "ອຸປະກອນການສະໜອງ",
    "system.label.ItemClass": "ຄາດລາດສິນຄ້າ",
    "system.label.ProvisioningSystem": "ລະບົບການສະໜອງ",
    "system.label.Create": "ສ້າງ",
    "system.label.CreateHardwarePlan": "ສ້າງແຜນການສ້າງສັນຂອງອຸປະກອນ",
    "system.label.EditHardwarePlan": "ແກ້ໄຂແຜນການສ້າງສັນຂອງອຸປະກອນ",
    "system.label.ProvisionCommand": "ຄຳສັ່ງການສະໜອງ",
    "system.label.ProvisioningSystem": "ລະບົບການສະໜອງ",
    "system.label.CommandName": "ຊື່ຄຳສັ່ງ",
    "system.label.Status": "ສະຖານະ",
    "system.label.Parameters": "ພາລາມິເຕີ",
    "system.label.CreateProvisioningMapping": "ສ້າງການຈັດຮຽງສະໜອງ",
    "system.label.CommandParams": "ພາລາມິເຕີຂອງຄຳສັ່ງ",
    "system.label.ParamDefault": "ຄ່າເລີ່ມຕົ້ນຂອງພາລາມິເຕີ",
    "system.label.ParamLength": "ຄວາມຍາວຂອງພາລາມິເຕີ",
    "system.label.ParamNotes": "ຫມາຍເຫດຂອງພາລາມິເຕີ",
    "system.label.ParamType": "ປະເພດຂອງພາລາມິເຕີ",
    "system.label.AutoGenerate": "ສ້າງໂດຍອັດຕະໂນມັດ",
    "system.label.ViewProvisioningMapping": "ເບິ່ງການຈັດຮຽງສະໜອງ",
    "system.label.CommandParameter": "ພາລາມິເຕີຂອງຄຳສັ່ງ",
    "system.label.Edit": "ແກ້ໄຂ",
    "system.label.Delete": "ລຶບ",
    "system.label.DeleteProvisionCommand": "ລຶບຄຳສັ່ງການສະໜອງ",
    "system.label.AreYouSure": "ແມ່ນແນ່ວ່າເຈົ້າຕ້ອງການບໍ?",
    "system.label.Ok": "ໂອເຄ",
    "system.label.EditProvisioningMapping": "ແກ້ໄຂການຈັດຮຽງສະໜອງ",
    "system.label.Id": "Id",
    "system.label.ParamName": "ຊື່ພາລາມິເຕີ",
    "system.label.ProvisioningActions": "ການປະຕິບັດການຈັດຫາ",
    "system.label.ProvisionType": "ປະເພດການຈັດຫາ",
    "system.label.IsEnable": "ເປີດໃຊ້",
    "system.label.NetworkSystem": "ລະບົບເຄືອຂ່າຍ",
    "system.label.SystemCode": "ລະຫັດລະບົບ",
    "system.label.SystemName": "ຊື່ລະບົບ",
    "system.label.CreateNetworkSystem": "ສ້າງລະບົບເຄືອຂ່າຍ",
    "system.label.GroupSupported": "ກຸ່ມທີ່ສະໜັບສະໜູນ",
    "system.label.EditNetworkSystem": "ແກ້ໄຂລະບົບເຄືອຂ່າຍ",
    "system.label.DeleteNetworkSystem": "ລຶບລະບົບເຄືອຂ່າຍ",
    "system.label.ManageReports": "ຄຸ້ມຄອງລາຍງານ",
    "system.label.ReportName": "ຊື່ລາຍງານ",
    "system.label.AddressMasterTreeView": "ເບິ່ງເຕັ້ນຫຼັກຂອງທີ່ຢູ່",
    "system.label.ReportType": "ປະເພດລາຍງານ",
    "system.label.ReportSubtype": "ປະເພດຍ່ອຍຂອງລາຍງານ",
    "system.label.ReportCategory": "ປະເພດລາຍງານ",
    "system.label.CoreReport": "ລາຍງານຫຼັກ",
    "system.label.UserReport": "ລາຍງານຜູ້ໃຊ້",
    "system.label.CreateReport": "ສ້າງລາຍງານ",
    "system.label.ReportDetails": "ລາຍລະອຽດລາຍງານ",
    "system.label.UserReportUI": "ລາຍງານຜູ້ໃຊ້ (UI)",
    "system.label.isScheduled": "ຖືກກຳຫນົດໄວ້",
    "system.label.Description": "ລາຍລະອຽດ",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "ພາລາມິເຕີລາຍງານ",
    "system.label.AllowedParameters": "ພາລາມິເຕີທີ່ອະນຸຍາດ",
    "system.label.CreateParameter": "ສ້າງພາລາມິເຕີ",
    "system.label.Parameter": "ພາລາມິເຕີ",
    "system.label.ParameterNamePassedToPentaoh":
      "ຊື່ພາລາມິເຕີທີ່ຜ່ານໄປໃຫ້ Pentaoh",
    "system.label.Reset": "ຣີເຊັດ",
    "system.label.EditReport": "ແກ້ໄຂລາຍງານ",
    "system.label.DeleteReports": "ລຶບລາຍງານ",
    "system.label.ManageCodes": "ຄຸ້ມຄອງລະຫັດ",
    "system.label.CodeModule": "ໂມດູນລະຫັດ",
    "system.label.SystemDefined": "ກຳນົດໂດຍລະບົບ",
    "system.label.CreateCode": "ສ້າງລະຫັດ",
    "system.label.AddCode": "ເພີ່ມລະຫັດ",
    "system.label.Module": "ໂມດູນ",
    "system.label.EditManageCodes": "ແກ້ໄຂການຄຸ້ມຄອງລະຫັດ",
    "system.label.CodeValue": "ຄ່າລະຫັດ",
    "system.label.Position": "ຕຳແໜ່ງ",
    "system.label.Create": "ສ້າງ",
    "system.label.DeleteManageCodes": "ລຶບການຄຸ້ມຄອງລະຫັດ",
    "system.label.ViewManageCodes": "ເບິ່ງການຄຸ້ມຄອງລະຫັດ",
    "system.label.Name": "ຊື່",
    "system.label.Add": "ເພີ່ມ",
    "system.label.CodeName": "ຊື່ລະຫັດ",
    "system.label.Submit": "ສົ່ງ",
    "system.label.isSynchronous": "ເປັນການປະສານກັນ",

    "system.label.EnterServiceDescription": "ໃສ່ຄຳອະທິບາຍການບໍລິການ",
    "system.label.Questions": "ຄຳຖາມ",
    "system.label.Id": "ID",
    "system.label.QuestionType": "ປະເພດຄຳຖາມ",
    "system.label.QuestionText": "ຂໍ້ຄວາມຄຳຖາມ",
  },

  my_MM: {
    "system.label.ManageMessage": "မက်ဆေ့ချ်ကိုစီမံပါ",
    "system.label.Role": "အခန်းကဏ္ဍ",
    "system.label.Enabled": "ဖွင့်ထားသည်",
    "system.label.Enter_service_Description": "ဝန်ဆောင်မှုဖော်ပြချက် ထည့်ပါ",
    "system.label.Manage_Report": "အစီရင်ခံစာကိုစီမံပါ",
    "system.label.Reports": "အစီရင်ခံစာများ",
    "system.label.Create": "ဖန်တီးပါ",
    "system.label.Edit": "တည်းဖြတ်ပါ",
    "system.label.Delete": "ဖျက်ပါ",
    "system.label.role": "အခန်းကဏ္ဍ",
    "system.label.clientName": "ဖောက်သည်အမည်",
    "system.label.assignedRoles": "တာဝန်ချထားသောအခန်းကဏ္ဍများ",
    "system.label.editRole": "အခန်းကဏ္ဍကို ပြင်ဆင်ပါ",
    "system.label.NetworkSystem": "ကွန်ယက်စနစ်",
    "system.label.ManageCode": "ကုဒ်ကိုစီမံရန်",
    "system.label.ViewShift": "အလှည့်အချိန် ကြည့်ရန်",
    "system.label.HolidayManagement": "အားလပ်ရက် စီမံခန့်ခွဲမှု",
    "system.label.CreateHoliday": "အားလပ်ရက် ဖန်တီးရန်",
    "system.label.EditHoliday": "အားလပ်ရက် တည်းဖြတ်ရန်",
    "system.label.ViewHoliday": "အားလပ်ရက် ကြည့်ရန်",
    "system.label.HolidayTitle": "အားလပ်ရက် ခေါင်းစဉ်",
    "system.label.Days": "ရက်များ",
    "system.label.HolidayType": "အားလပ်ရက် အမျိုးအစား",
    "system.label.WeeklyHolidays": "အပတ်စဉ်အားလပ်ရက်များ",
    "system.label.SessionName": "အစည်းအဝေးအမည်",
    "system.label.SessionDate": "အစည်းအဝေးရက်စွဲ",
    "system.label.Add": "ထည့်ရန်",
    "system.label.ViewEventActionMapping":
      "အဖြစ်အပျက်လှုပ်ရှားမှုစီမံချက်ကြည့်ရန်",
    "system.label.Event": "ဖြစ်စဉ်",
    "system.label.Action": "လုပ်ဆောင်မှု",
    "system.label.OrderBY": "စဉ်ရန်",
    "system.label.ProcessParams": "လုပ်ငန်းစဉ်အချက်အလက်များ",
    "system.label.AddConfiguration": "ပြင်ဆင်မှုထည့်ရန်",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "ENUM အမည်",
    "system.label.ENUM_Id": "ENUM ID",
    "system.label.ENUM_Property": "ENUM ဂုဏ်သတ္တိ",
    "system.label.ENUM_Value": "ENUM တန်ဖိုး",
    "system.label.Create_Enum": "ENUM ဖန်တီးပါ",
    "system.label.ExternalSystem": "ပြင်ပစနစ်",
    "system.label.CreateDevice": "စက်ပစ္စည်းဖန်တီးပါ",
    "system.label.ExternalSystem": "ပြင်ပစနစ်",
    "system.label.userName": "အသုံးပြုသူအမည်",
    "system.label.firstName": "နာမည်",
    "system.label.lastName": "မှတ်ပုံတင်အမည်",
    "system.label.email": "အီးမေးလ်",
    "system.label.officeName": "ရုံးအမည်",
    "system.label.action": "လုပ်ဆောင်ချက်",
    "system.label.createUser": "အသုံးပြုသူအသစ်ဖန်တီးပါ",
    "system.label.users": "အသုံးပြုသူများ",
    "system.label.View": "ကြည့်ရန်",
    "system.label.Property": "ပိုင်ဆိုင်မှု",
    "system.label.edit": "ပြင်ဆင်ရန်",
    "system.label.delete": "ဖျက်ပစ်ရန်",
    "system.label.loginName": "လိုင်စင်အမည်",
    "system.label.entityName": "စနစ်အမည်",
    "system.label.roles": "လိုင်စင်များ",
    "system.label.changePassword": "စကားဝှက်အားပြောင်းရန်",
    "system.label.password": "စကားဝှက်",
    "system.label.repeatPassword": "စကားဝှက်ထပ်ပို့ရန်",
    "system.label.cancel": "ပယ်ဖျက်ရန်",
    "system.label.itemdescription": "ပစ္စည်းအကြောင်းအရာ",
    "system.label.save": "သိမ်းဆည်းရန်",
    "system.label.deleteUser": "အသုံးပြုသူအဖွဲ့မယ်",
    "system.label.areYouSure": "သေချာပါသလား?",
    "system.label.ok": "အိုကေ",
    "system.label.editUser": "အသုံးပြုသူတည်းဖြတ်ရန်",
    "system.label.availableRoles": "ရရှိနိုင်သောလိုင်စင်များ",
    "system.label.selectedRoles": "ရွေးချယ်ထားသောရာထူးများ",
    "system.label.entity": "လုပ်ငန်း",
    "system.label.submit": "တင်သွင်းပါ",
    "system.label.createUser": "အသုံးပြုသူတစ်ယောက်ဖန်တီးပါ",
    "system.label.autoGeneratePassword":
      "စကားဝှက်ကိုလည်ပတ်ရန်အလုပ်အကိုင်ဖြစ်စေခြင်း",
    "system.label.reset": "ထပ်တူကျပါ",
    "system.label.areYouSureDelete": "သေချာပါသလားဖျက်မှာသေချာပါသလား?",
    "system.label.confirm": "အတည်ပြု",
    "system.label.createRole": "ယိုယနှင့်အကုန်လုပ်ငန်းဖန်တီးပါ",
    "system.label.name": "နာမည်",
    "system.label.description": "ဖော်ပြချက်",
    "system.label.permissions": "လိုင်စင်များ",
    "system.label.currencyConfig": "ငွေကြေးစီမူဝါဒ",
    "system.label.createCurrency": "ငွေကြေးစီဖန်တီးပါ",
    "system.label.code": "ကုဒ်",
    "system.label.internationalNameCode": "အမျိုးအစားနိုင်ငံတစ်နိုင်ငံနယ်ကို",
    "system.label.decimalPlaces": "ဒယ်နံပါတ်များ",
    "system.label.displaySymbol": "ပြသပိတ်အမှတ်",
    "system.label.viewCurrency": "ငွေကြေးစီကြည့်ရန်",
    "system.label.countryCode": "နိုင်ငံကုဒ်",
    "system.label.countryName": "နိုင်ငံအမည်",
    "system.label.displaySymbol": "ပြသပိတ်အမှတ်",
    "system.label.createCurrencyMaster": "ငွေကြေးစီမြင့်တင်မည်",
    "system.label.currency": "ငွေကြေးစီ",
    "system.label.nonCurrency": "ငွေကြေးစီမဟုတ်သော",
    "system.label.editCurrencyConfiguration": "ငွေကြေးစီပြင်ဆင်မည်",
    "system.label.deleteCurrency": "ငွေကြေးစီဖျက်မှု",
    "system.label.deleteNonCurrency": "ငွေကြေးမဟုတ်သောအား ဖျက်ပါ",
    "system.label.areYouSureDelete": "သေချာပါသလားဖျက်မှာသေချာပါသလား?",
    "system.label.currencyExchange": "ငွေကြေးစီအကူအညီ",
    "system.label.createExchange": "အကူအညီဖန်တီးပါ",
    "system.label.id": "Id",
    "system.label.baseCurrency": "ဘောင်းကုန်ကိုင်",
    "system.label.conversionCurrency": "ဘောင်းပြောင်းခြင်းငွေ",
    "system.label.conversionRate": "ဘောင်းပြောင်းခြေနှုန်း",
    "system.label.status": "အခြေအနေ",
    "system.label.validFrom": "မှ",
    "system.label.validTo": "သို့မဟုတ်",
    "system.label.deleteCurrencyExchange": "ငွေကြေးစီအကူအညီဖျက်မှု",
    "system.label.viewCurrencyExchange": "ငွေကြေးစီအကူအညီကြည့်ရန်",
    "system.label.createCurrencyExchange": "ငွေကြေးစီအကူအညီဖန်တီးပါ",
    "system.label.editCurrencyExchange": "ငွေကြေးစီအကူအညီပြင်ဆင်မည်",
    "system.label.GlobalConfiguration": "ကမ္ဘာလုံးဆိုင်ရာဖွဲ့စည်းပုံ",
    "system.label.Module": "မော်ဂျူး",
    "system.label.Name": "အမည်",
    "system.label.Description": "ဖော်ပြချက်",
    "system.label.Value": "တန်ဖိုး",
    "system.label.Enabled": "ဖွင့်ထားသည်",
    "system.label.Flag": "အလံ",
    "system.label.Action": "လှုပ်ရှားမှု",
    "system.label.EditGlobalConfiguration":
      "ကမ္ဘာလုံးဆိုင်ရာဖွဲ့စည်းပုံကိုတည်းဖြတ်ပါ",
    "system.label.PaymentGatewayConfiguration": "ငွေပေးချေမှုဂိတ်ဖွဲ့စည်းပုံ",
    "system.label.EditPaymentGatewayConfiguration":
      "ငွေပေးချေမှုဂိတ်ဖွဲ့စည်းပုံကိုတည်းဖြတ်ပါ",
    "system.label.Key": "Key",
    "system.label.EnterKeyHere": "Key ကိုဤနေရာတွင်ရိုက်ထည့်ပါ",
    "system.label.EnterValueHere": "တန်ဖိုးကိုဤနေရာတွင်ရိုက်ထည့်ပါ",
    "system.label.Hooks": "ဟုန်းများ",
    "system.label.Event": "ပွဲ",
    "system.label.Name": "အမည်",
    "system.label.Description": "ဖော်ပြချက်",
    "system.label.Value": "တန်ဖိုး",
    "system.label.Enabled": "ဖွင့်ထားသည်",
    "system.label.Flag": "အလံ",
    "system.label.Action": "လှုပ်ရှားမှု",
    "system.label.Process": "ဖြစ်စဉ်",
    "system.label.OrderBy": "အဆင့်လိုက်",
    "system.label.PrePost": "PrePost",
    "system.label.ProcessParams": "ဖြစ်စဉ်အချက်အလက်များ",
    "system.label.IsSynchronous": "ချိတ်ဆက်ထားခြင်းဖြစ်ပါသလား",
    "system.label.Actions": "လှုပ်ရှားမှုများ",
    "system.label.CreateEvent": "ပွဲဖြစ်စဉ်ကို ဖန်တီးပါ",
    "system.label.CreateEventActionMapping":
      "ပွဲဖြစ်စဉ် လှုပ်ရှားမှု မြေပုံဖန်တီးပါ",
    "system.label.AutoGeneratePassword": "စကားဝှက်ကို အလိုအလျောက်ဖန်တီးပါ",
    "system.label.EditEventActionMapping":
      "ပွဲဖြစ်စဉ် လှုပ်ရှားမှု မြေပုံကို တည်းဖြတ်ပါ",
    "system.label.ProvisioningDevice": "ပေးဆောင်ရေးစက်",
    "system.label.ItemClass": "ပစ္စည်းတန်း",
    "system.label.ProvisioningSystem": "ပေးဆောင်ရေးစနစ်",
    "system.label.Create": "ဖန်တီးပါ",
    "system.label.CreateHardwarePlan": "စက်ပစ္စည်းအစီအစဉ် ဖန်တီးပါ",
    "system.label.EditHardwarePlan": "စက်ပစ္စည်းအစီအစဉ်ကို တည်းဖြတ်ပါ",
    "system.label.ProvisionCommand": "ပေးဆောင်ရေး အမိန့်",
    "system.label.ProvisioningSystem": "ပေးဆောင်ရေးစနစ်",
    "system.label.CommandName": "အမိန့် အမည်",
    "system.label.Status": "အခြေအနေ",
    "system.label.Parameters": "ပါရာမီတာများ",
    "system.label.CreateProvisioningMapping": "ပေးဆောင်ရေးမြေပုံဖန်တီးပါ",
    "system.label.CommandParams": "အမိန့် ပါရာမီတာများ",
    "system.label.ParamDefault": "ပါရာမီတာ ပုံသေတန်ဖိုး",
    "system.label.ParamLength": "ပါရာမီတာ အလျား",
    "system.label.ParamNotes": "ပါရာမီတာ မှတ်ချက်များ",
    "system.label.ParamType": "ပါရာမီတာ အမျိုးအစား",
    "system.label.AutoGenerate": "အလိုအလျောက်ဖန်တီးပါ",
    "system.label.ViewProvisioningMapping": "ပေးဆောင်ရေး မြေပုံကြည့်ပါ",
    "system.label.CommandParameter": "အမိန့် ပါရာမီတာ",
    "system.label.Edit": "တည်းဖြတ်ပါ",
    "system.label.Delete": "ဖျက်ပါ",
    "system.label.DeleteProvisionCommand": "ပေးဆောင်ရေး အမိန့် ဖျက်ပါ",
    "system.label.AreYouSure": "သေချာပါသလား?",
    "system.label.Ok": "အိုကေ",
    "system.label.EditProvisioningMapping": "ပေးဆောင်ရေး မြေပုံကို တည်းဖြတ်ပါ",
    "system.label.Id": "ID",
    "system.label.ParamName": "ပါရာမီတာ အမည်",
    "system.label.ProvisioningActions": "ပေးဆောင်ရေး လှုပ်ရှားမှုများ",
    "system.label.ProvisionType": "ပေးဆောင်ရေး အမျိုးအစား",
    "system.label.IsEnable": "ဖွင့်ထားသည်",
    "system.label.NetworkSystem": "ကွန်ယက်စနစ်",
    "system.label.SystemCode": "စနစ်ကုဒ်",
    "system.label.SystemName": "စနစ်အမည်",
    "system.label.CreateNetworkSystem": "ကွန်ယက်စနစ် ဖန်တီးပါ",
    "system.label.GroupSupported": "အဖွဲ့အားပေးသည်",
    "system.label.EditNetworkSystem": "ကွန်ယက်စနစ်ကို တည်းဖြတ်ပါ",
    "system.label.DeleteNetworkSystem": "ကွန်ယက်စနစ်ကို ဖျက်ပါ",
    "system.label.ManageReports": "အစီရင်ခံစာ စီမံခန့်ခွဲခြင်း",
    "system.label.ReportName": "အစီရင်ခံစာအမည်",
    "system.label.AddressMasterTreeView": "လိပ်စာမော်ဒယ်ပုစ္စာကြိုးမြင်ကွင်း",
    "system.label.ReportType": "အစီရင်ခံစာ အမျိုးအစား",
    "system.label.ReportSubtype": "အစီရင်ခံစာ အမျိုးအစားခွဲ",
    "system.label.ReportCategory": "အစီရင်ခံစာ အမျိုးအစားအုပ်စု",
    "system.label.CoreReport": "အဓိကအစီရင်ခံစာ",
    "system.label.UserReport": "အသုံးပြုသူ အစီရင်ခံစာ",
    "system.label.CreateReport": "အစီရင်ခံစာဖန်တီးပါ",
    "system.label.ReportDetails": "အစီရင်ခံစာအသေးစိတ်",
    "system.label.UserReportUI": "အသုံးပြုသူအစီရင်ခံစာ (UI)",
    "system.label.isScheduled": "အစီရင်ခံစာချိန်ဇယားထား",
    "system.label.Description": "ဖော်ပြချက်",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "အစီရင်ခံစာဆိုင်ရာ ပါရာမီတာများ",
    "system.label.AllowedParameters": "ခွင့်ပြုထားသော ပါရာမီတာများ",
    "system.label.CreateParameter": "ပါရာမီတာ ဖန်တီးပါ",
    "system.label.Parameter": "ပါရာမီတာ",
    "system.label.ParameterNamePassedToPentaoh":
      "Pentaoh သို့ ပေးပို့မည့် ပါရာမီတာအမည်",
    "system.label.Reset": "ပြန်စလုပ်မည်",
    "system.label.EditReport": "အစီရင်ခံစာတည်းဖြတ်ပါ",
    "system.label.DeleteReports": "အစီရင်ခံစာများကို ဖျက်ပါ",
    "system.label.ManageCodes": "ကုဒ်များ စီမံခန့်ခွဲခြင်း",
    "system.label.CodeModule": "ကုဒ် မော်ဂျူး",
    "system.label.SystemDefined": "စနစ်အတိုင်း သတ်မှတ်ထားသည်",
    "system.label.CreateCode": "ကုဒ်ဖန်တီးပါ။",
    "system.label.AddCode": "ကုဒ်ထည့်ပါ",
    "system.label.Module": "မော်ဂျူး",
    "system.label.EditManageCodes": "ကုဒ်များ စီမံခန့်ခွဲမှုတည်းဖြတ်ပါ",
    "system.label.CodeValue": "ကုဒ်တန်ဖိုး",
    "system.label.Position": "နေရာ",
    "system.label.Create": "ဖန်တီးပါ",
    "system.label.DeleteManageCodes": "ကုဒ်များ စီမံခန့်ခွဲမှု ဖျက်ပါ",
    "system.label.ViewManageCodes": "ကုဒ်များ စီမံခန့်ခွဲမှု ကြည့်ပါ",
    "system.label.Name": "အမည်",
    "system.label.Add": "ထည့်ပါ",
    "system.label.CodeName": "ကုဒ်အမည်",
    "system.label.Submit": "တင်သွင်းပါ",
    "system.label.isSynchronous": "同步ဖြစ်ပါသည်",

    "system.label.EnterServiceDescription": "ဝန်ဆောင်မှုဖော်ပြချက်ကို ထည့်ပါ",
    "system.label.Questions": "မေးခွန်းများ",
    "system.label.Id": "အိုင်ဒီ",
    "system.label.QuestionType": "မေးခွန်းအမျိုးအစား",
    "system.label.QuestionText": "မေးခွန်းစာသား",
  },

  my: {
    "system.label.ManageMessage": "မက်ဆေ့ချ်ကိုစီမံပါ",
    "system.label.Role": "အခန်းကဏ္ဍ",
    "system.label.Enabled": "ဖွင့်ထားသည်",
    "system.label.Enter_service_Description": "ဝန်ဆောင်မှုဖော်ပြချက် ထည့်ပါ",
    "system.label.Manage_Report": "အစီရင်ခံစာကိုစီမံပါ",
    "system.label.Reports": "အစီရင်ခံစာများ",
    "system.label.Create": "ဖန်တီးပါ",
    "system.label.Edit": "တည်းဖြတ်ပါ",
    "system.label.Delete": "ဖျက်ပါ",
    "system.label.role": "အခန်းကဏ္ဍ",
    "system.label.clientName": "ဖောက်သည်အမည်",
    "system.label.assignedRoles": "တာဝန်ချထားသောအခန်းကဏ္ဍများ",
    "system.label.editRole": "အခန်းကဏ္ဍကို ပြင်ဆင်ပါ",
    "system.label.NetworkSystem": "ကွန်ယက်စနစ်",
    "system.label.ManageCode": "ကုဒ်ကိုစီမံရန်",
    "system.label.ViewShift": "အလှည့်အချိန် ကြည့်ရန်",
    "system.label.HolidayManagement": "အားလပ်ရက် စီမံခန့်ခွဲမှု",
    "system.label.CreateHoliday": "အားလပ်ရက် ဖန်တီးရန်",
    "system.label.EditHoliday": "အားလပ်ရက် တည်းဖြတ်ရန်",
    "system.label.ViewHoliday": "အားလပ်ရက် ကြည့်ရန်",
    "system.label.HolidayTitle": "အားလပ်ရက် ခေါင်းစဉ်",
    "system.label.Days": "ရက်များ",
    "system.label.HolidayType": "အားလပ်ရက် အမျိုးအစား",
    "system.label.WeeklyHolidays": "အပတ်စဉ်အားလပ်ရက်များ",
    "system.label.SessionName": "အစည်းအဝေးအမည်",
    "system.label.SessionDate": "အစည်းအဝေးရက်စွဲ",
    "system.label.Add": "ထည့်ရန်",
    "system.label.ViewEventActionMapping":
      "အဖြစ်အပျက်လှုပ်ရှားမှုစီမံချက်ကြည့်ရန်",
    "system.label.Event": "ဖြစ်စဉ်",
    "system.label.Action": "လုပ်ဆောင်မှု",
    "system.label.OrderBY": "စဉ်ရန်",
    "system.label.ProcessParams": "လုပ်ငန်းစဉ်အချက်အလက်များ",
    "system.label.AddConfiguration": "ပြင်ဆင်မှုထည့်ရန်",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "ENUM အမည်",
    "system.label.ENUM_Id": "ENUM ID",
    "system.label.ENUM_Property": "ENUM ဂုဏ်သတ္တိ",
    "system.label.ENUM_Value": "ENUM တန်ဖိုး",
    "system.label.Create_Enum": "ENUM ဖန်တီးပါ",
    "system.label.ExternalSystem": "ပြင်ပစနစ်",
    "system.label.CreateDevice": "စက်ပစ္စည်းဖန်တီးပါ",
    "system.label.ExternalSystem": "ပြင်ပစနစ်",
    "system.label.userName": "အသုံးပြုသူအမည်",
    "system.label.firstName": "နာမည်",
    "system.label.lastName": "မှတ်ပုံတင်အမည်",
    "system.label.email": "အီးမေးလ်",
    "system.label.officeName": "ရုံးအမည်",
    "system.label.action": "လုပ်ဆောင်ချက်",
    "system.label.createUser": "အသုံးပြုသူအသစ်ဖန်တီးပါ",
    "system.label.users": "အသုံးပြုသူများ",
    "system.label.View": "ကြည့်ရန်",
    "system.label.Property": "ပိုင်ဆိုင်မှု",
    "system.label.edit": "ပြင်ဆင်ရန်",
    "system.label.delete": "ဖျက်ပစ်ရန်",
    "system.label.loginName": "လိုင်စင်အမည်",
    "system.label.entityName": "စနစ်အမည်",
    "system.label.roles": "လိုင်စင်များ",
    "system.label.changePassword": "စကားဝှက်ပြောင်းရန်",
    "system.label.password": "စကားဝှက်",
    "system.label.repeatPassword": "စကားဝှက်ထပ်ပို့ရန်",
    "system.label.cancel": "ပယ်ဖျက်ရန်",
    "system.label.itemdescription": "ပစ္စည်းအကြောင်းအရာ",
    "system.label.save": "သိမ်းဆည်းရန်",
    "system.label.deleteUser": "အသုံးပြုသူအဖွဲ့ဖျက်မယ်",
    "system.label.areYouSure": "သေချာပါသလား?",
    "system.label.ok": "အိုကေ",
    "system.label.editUser": "အသုံးပြုသူတည်းဖြတ်ပါ",
    "system.label.availableRoles": "ရရှိနိုင်သောလိုင်စင်များ",
    "system.label.selectedRoles": "ရွေးချယ်ထားသောရာထူးများ",
    "system.label.entity": "လုပ်ငန်း",
    "system.label.submit": "တင်သွင်းပါ",
    "system.label.createUser": "အသုံးပြုသူတစ်ယောက်ဖန်တီးပါ",
    "system.label.autoGeneratePassword":
      "စကားဝှက်ကိုလည်ပတ်ရန်အလုပ်အကိုင်ဖြစ်စေခြင်း",
    "system.label.reset": "ထပ်တူကျပါ",
    "system.label.areYouSureDelete": "သေချာပါသလားဖျက်မှာသေချာပါသလား?",
    "system.label.confirm": "အတည်ပြု",
    "system.label.createRole": "ယိုယနှင့်အကုန်လုပ်ငန်းဖန်တီးပါ",
    "system.label.name": "နာမည်",
    "system.label.description": "ဖော်ပြချက်",
    "system.label.permissions": "လိုင်စင်များ",
    "system.label.currencyConfig": "ငွေကြေးစီမူဝါဒ",
    "system.label.createCurrency": "ငွေကြေးစီဖန်တီးပါ",
    "system.label.code": "ကုဒ်",
    "system.label.internationalNameCode": "အမျိုးအစားနိုင်ငံတစ်နိုင်ငံနယ်ကို",
    "system.label.decimalPlaces": "ဒယ်နံပါတ်များ",
    "system.label.displaySymbol": "ပြသပိတ်အမှတ်",
    "system.label.viewCurrency": "ငွေကြေးစီကြည့်ရန်",
    "system.label.countryCode": "နိုင်ငံကုဒ်",
    "system.label.countryName": "နိုင်ငံအမည်",
    "system.label.displaySymbol": "ပြသပိတ်အမှတ်",
    "system.label.createCurrencyMaster": "ငွေကြေးစီမြင့်တင်မည်",
    "system.label.currency": "ငွေကြေးစီ",
    "system.label.nonCurrency": "ငွေကြေးစီမဟုတ်သော",
    "system.label.editCurrencyConfiguration": "ငွေကြေးစီပြင်ဆင်မည်",
    "system.label.deleteCurrency": "ငွေကြေးစီဖျက်မှု",
    "system.label.deleteNonCurrency": "ငွေကြေးမဟုတ်သောအား ဖျက်ပါ",
    "system.label.areYouSureDelete": "သေချာပါသလားဖျက်မှာသေချာပါသလား?",
    "system.label.currencyExchange": "ငွေကြေးစီအကူအညီ",
    "system.label.createExchange": "အကူအညီဖန်တီးပါ",
    "system.label.id": "Id",
    "system.label.baseCurrency": "ဘောင်းကုန်ကိုင်",
    "system.label.conversionCurrency": "ဘောင်းပြောင်းခြင်းငွေ",
    "system.label.conversionRate": "ဘောင်းပြောင်းခြေနှုန်း",
    "system.label.status": "အခြေအနေ",
    "system.label.validFrom": "မှ",
    "system.label.validTo": "သို့မဟုတ်",
    "system.label.deleteCurrencyExchange": "ငွေကြေးစီအကူအညီဖျက်မှု",
    "system.label.viewCurrencyExchange": "ငွေကြေးစီအကူအညီကြည့်ရန်",
    "system.label.createCurrencyExchange": "ငွေကြေးစီအကူအညီဖန်တီးပါ",
    "system.label.editCurrencyExchange": "ငွေကြေးစီအကူအညီပြင်ဆင်မည်",
    "system.label.GlobalConfiguration": "ကမ္ဘာလုံးဆိုင်ရာဖွဲ့စည်းပုံ",
    "system.label.Module": "မော်ဂျူး",
    "system.label.Name": "အမည်",
    "system.label.Description": "ဖော်ပြချက်",
    "system.label.Value": "တန်ဖိုး",
    "system.label.Enabled": "ဖွင့်ထားသည်",
    "system.label.Flag": "အလံ",
    "system.label.Action": "လှုပ်ရှားမှု",
    "system.label.EditGlobalConfiguration":
      "ကမ္ဘာလုံးဆိုင်ရာဖွဲ့စည်းပုံကိုတည်းဖြတ်ပါ",
    "system.label.PaymentGatewayConfiguration": "ငွေပေးချေမှုဂိတ်ဖွဲ့စည်းပုံ",
    "system.label.EditPaymentGatewayConfiguration":
      "ငွေပေးချေမှုဂိတ်ဖွဲ့စည်းပုံကိုတည်းဖြတ်ပါ",
    "system.label.Key": "Key",
    "system.label.EnterKeyHere": "Key ကိုဤနေရာတွင်ရိုက်ထည့်ပါ",
    "system.label.EnterValueHere": "တန်ဖိုးကိုဤနေရာတွင်ရိုက်ထည့်ပါ",
    "system.label.Hooks": "ဟုန်းများ",
    "system.label.Event": "ပွဲ",
    "system.label.Name": "အမည်",
    "system.label.Description": "ဖော်ပြချက်",
    "system.label.Value": "တန်ဖိုး",
    "system.label.Enabled": "ဖွင့်ထားသည်",
    "system.label.Flag": "အလံ",
    "system.label.Action": "လှုပ်ရှားမှု",
    "system.label.Process": "ဖြစ်စဉ်",
    "system.label.OrderBy": "အဆင့်လိုက်",
    "system.label.PrePost": "PrePost",
    "system.label.ProcessParams": "ဖြစ်စဉ်အချက်အလက်များ",
    "system.label.IsSynchronous": "ချိတ်ဆက်ထားခြင်းဖြစ်ပါသလား",
    "system.label.Actions": "လှုပ်ရှားမှုများ",
    "system.label.CreateEvent": "ပွဲဖြစ်စဉ်ကို ဖန်တီးပါ",
    "system.label.CreateEventActionMapping":
      "ပွဲဖြစ်စဉ် လှုပ်ရှားမှု မြေပုံဖန်တီးပါ",
    "system.label.AutoGeneratePassword": "စကားဝှက်ကို အလိုအလျောက်ဖန်တီးပါ",
    "system.label.EditEventActionMapping":
      "ပွဲဖြစ်စဉ် လှုပ်ရှားမှု မြေပုံကို တည်းဖြတ်ပါ",
    "system.label.ProvisioningDevice": "ပေးဆောင်ရေးစက်",
    "system.label.ItemClass": "ပစ္စည်းတန်း",
    "system.label.ProvisioningSystem": "ပေးဆောင်ရေးစနစ်",
    "system.label.Create": "ဖန်တီးပါ",
    "system.label.CreateHardwarePlan": "စက်ပစ္စည်းအစီအစဉ် ဖန်တီးပါ",
    "system.label.EditHardwarePlan": "စက်ပစ္စည်းအစီအစဉ်ကို တည်းဖြတ်ပါ",
    "system.label.ProvisionCommand": "ပေးဆောင်ရေး အမိန့်",
    "system.label.ProvisioningSystem": "ပေးဆောင်ရေးစနစ်",
    "system.label.CommandName": "အမိန့် အမည်",
    "system.label.Status": "အခြေအနေ",
    "system.label.Parameters": "ပါရာမီတာများ",
    "system.label.CreateProvisioningMapping": "ပေးဆောင်ရေးမြေပုံဖန်တီးပါ",
    "system.label.CommandParams": "အမိန့် ပါရာမီတာများ",
    "system.label.ParamDefault": "ပါရာမီတာ ပုံသေတန်ဖိုး",
    "system.label.ParamLength": "ပါရာမီတာ အလျား",
    "system.label.ParamNotes": "ပါရာမီတာ မှတ်ချက်များ",
    "system.label.ParamType": "ပါရာမီတာ အမျိုးအစား",
    "system.label.AutoGenerate": "အလိုအလျောက်ဖန်တီးပါ",
    "system.label.ViewProvisioningMapping": "ပေးဆောင်ရေး မြေပုံကြည့်ပါ",
    "system.label.CommandParameter": "အမိန့် ပါရာမီတာ",
    "system.label.Edit": "တည်းဖြတ်ပါ",
    "system.label.Delete": "ဖျက်ပါ",
    "system.label.DeleteProvisionCommand": "ပေးဆောင်ရေး အမိန့် ဖျက်ပါ",
    "system.label.AreYouSure": "သေချာပါသလား?",
    "system.label.Ok": "အိုကေ",
    "system.label.EditProvisioningMapping": "ပေးဆောင်ရေး မြေပုံကို တည်းဖြတ်ပါ",
    "system.label.Id": "ID",
    "system.label.ParamName": "ပါရာမီတာ အမည်",
    "system.label.ProvisioningActions": "ပေးဆောင်ရေး လှုပ်ရှားမှုများ",
    "system.label.ProvisionType": "ပေးဆောင်ရေး အမျိုးအစား",
    "system.label.IsEnable": "ဖွင့်ထားသည်",
    "system.label.NetworkSystem": "ကွန်ယက်စနစ်",
    "system.label.SystemCode": "စနစ်ကုဒ်",
    "system.label.SystemName": "စနစ်အမည်",
    "system.label.CreateNetworkSystem": "ကွန်ယက်စနစ် ဖန်တီးပါ",
    "system.label.GroupSupported": "အဖွဲ့အားပေးသည်",
    "system.label.EditNetworkSystem": "ကွန်ယက်စနစ်ကို တည်းဖြတ်ပါ",
    "system.label.DeleteNetworkSystem": "ကွန်ယက်စနစ်ကို ဖျက်ပါ",
    "system.label.ManageReports": "အစီရင်ခံစာ စီမံခန့်ခွဲခြင်း",
    "system.label.ReportName": "အစီရင်ခံစာအမည်",
    "system.label.AddressMasterTreeView": "လိပ်စာမူကြမ်းအဖွဲ့ရှုမြင်မှု",
    "system.label.ReportType": "အစီရင်ခံစာ အမျိုးအစား",
    "system.label.ReportSubtype": "အစီရင်ခံစာ အမျိုးအစားခွဲ",
    "system.label.ReportCategory": "အစီရင်ခံစာ အမျိုးအစားအုပ်စု",
    "system.label.CoreReport": "အဓိကအစီရင်ခံစာ",
    "system.label.UserReport": "အသုံးပြုသူ အစီရင်ခံစာ",
    "system.label.CreateReport": "အစီရင်ခံစာဖန်တီးပါ",
    "system.label.ReportDetails": "အစီရင်ခံစာအသေးစိတ်",
    "system.label.UserReportUI": "အသုံးပြုသူအစီရင်ခံစာ (UI)",
    "system.label.isScheduled": "အစီရင်ခံစာချိန်ဇယားထား",
    "system.label.Description": "ဖော်ပြချက်",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "အစီရင်ခံစာဆိုင်ရာ ပါရာမီတာများ",
    "system.label.AllowedParameters": "ခွင့်ပြုထားသော ပါရာမီတာများ",
    "system.label.CreateParameter": "ပါရာမီတာ ဖန်တီးပါ",
    "system.label.Parameter": "ပါရာမီတာ",
    "system.label.ParameterNamePassedToPentaoh":
      "Pentaoh သို့ ပေးပို့မည့် ပါရာမီတာအမည်",
    "system.label.Reset": "ပြန်စလုပ်မည်",
    "system.label.EditReport": "အစီရင်ခံစာတည်းဖြတ်ပါ",
    "system.label.DeleteReports": "အစီရင်ခံစာများကို ဖျက်ပါ",
    "system.label.ManageCodes": "ကုဒ်များ စီမံခန့်ခွဲခြင်း",
    "system.label.CodeModule": "ကုဒ် မော်ဂျူး",
    "system.label.SystemDefined": "စနစ်အတိုင်း သတ်မှတ်ထားသည်",
    "system.label.CreateCode": "ကုဒ်ဖန်တီးပါ။",
    "system.label.AddCode": "ကုဒ်ထည့်ပါ",
    "system.label.Module": "မော်ဂျူး",
    "system.label.EditManageCodes": "ကုဒ်များ စီမံခန့်ခွဲမှုတည်းဖြတ်ပါ",
    "system.label.CodeValue": "ကုဒ်တန်ဖိုး",
    "system.label.Position": "နေရာ",
    "system.label.Create": "ဖန်တီးပါ",
    "system.label.DeleteManageCodes": "ကုဒ်များ စီမံခန့်ခွဲမှု ဖျက်ပါ",
    "system.label.ViewManageCodes": "ကုဒ်များ စီမံခန့်ခွဲမှု ကြည့်ပါ",
    "system.label.Name": "အမည်",
    "system.label.Add": "ထည့်ပါ",
    "system.label.CodeName": "ကုဒ်အမည်",
    "system.label.Submit": "တင်သွင်းပါ",
    "system.label.isSynchronous": "同步ဖြစ်ပါသည်",

    "system.label.EnterServiceDescription": "ဝန်ဆောင်မှုဖော်ပြချက်ကို ထည့်ပါ",
    "system.label.Questions": "မေးခွန်းများ",
    "system.label.Id": "အိုင်ဒီ",
    "system.label.QuestionType": "မေးခွန်းအမျိုးအစား",
    "system.label.QuestionText": "မေးခွန်းစာသား",
  },

  vi: {
    "system.label.ManageMessage": "Quản lý tin nhắn",
    "system.label.Role": "Vai trò",
    "system.label.Enabled": "Đã bật",
    "system.label.Enter_service_Description": "Nhập mô tả dịch vụ",
    "system.label.Manage_Report": "Quản lý báo cáo",
    "system.label.Reports": "Báo cáo",
    "system.label.Create": "Tạo mới",
    "system.label.Edit": "Chỉnh sửa",
    "system.label.Delete": "Xóa",
    "system.label.role": "Vai trò",
    "system.label.clientName": "Tên khách hàng",
    "system.label.assignedRoles": "Vai trò được giao",
    "system.label.editRole": "Chỉnh sửa vai trò",
    "system.label.NetworkSystem": "Hệ thống mạng",
    "system.label.ManageCode": "Quản lý mã",
    "system.label.ViewShift": "Xem ca làm việc",
    "system.label.HolidayManagement": "Quản lý ngày nghỉ",
    "system.label.CreateHoliday": "Tạo ngày nghỉ",
    "system.label.EditHoliday": "Chỉnh sửa ngày nghỉ",
    "system.label.ViewHoliday": "Xem ngày nghỉ",
    "system.label.HolidayTitle": "Tiêu đề ngày nghỉ",
    "system.label.Days": "Số ngày",
    "system.label.HolidayType": "Loại ngày nghỉ",
    "system.label.WeeklyHolidays": "Ngày nghỉ hàng tuần",
    "system.label.SessionName": "Tên phiên làm việc",
    "system.label.SessionDate": "Ngày phiên làm việc",
    "system.label.Add": "Thêm",
    "system.label.ViewEventActionMapping": "Xem ánh xạ hành động sự kiện",
    "system.label.Event": "Sự kiện",
    "system.label.Action": "Hành động",
    "system.label.OrderBY": "Sắp xếp theo",
    "system.label.ProcessParams": "Tham số xử lý",
    "system.label.AddConfiguration": "Thêm cấu hình",
    "system.label.ENUM": "ENUM",
    "system.label.ENUM_Name": "Tên ENUM",
    "system.label.ENUM_Id": "ID ENUM",
    "system.label.ENUM_Property": "Thuộc tính ENUM",
    "system.label.ENUM_Value": "Giá trị ENUM",
    "system.label.Create_Enum": "Tạo ENUM",
    "system.label.ExternalSystem": "Hệ thống bên ngoài",
    "system.label.CreateDevice": "Tạo thiết bị",
    "system.label.ExternalSystem": "Hệ Thống Bên Ngoài",
    "system.label.userName": "Tên người dùng",
    "system.label.firstName": "Tên",
    "system.label.lastName": "Họ",
    "system.label.email": "Email",
    "system.label.officeName": "Tên văn phòng",
    "system.label.action": "Hành động",
    "system.label.createUser": "Tạo người dùng",
    "system.label.users": "Người dùng",
    "system.label.View": "Xem",
    "system.label.Property": "Tài sản",
    "system.label.edit": "Chỉnh sửa",
    "system.label.delete": "Xóa",
    "system.label.loginName": "Tên đăng nhập",
    "system.label.entityName": "Tên thực thể",
    "system.label.roles": "Vai trò",
    "system.label.changePassword": "Đổi mật khẩu",
    "system.label.password": "Mật khẩu",
    "system.label.repeatPassword": "Nhập lại mật khẩu",
    "system.label.cancel": "Hủy",
    "system.label.itemdescription": "Mô Tả Mặt Hàng",
    "system.label.save": "Lưu",
    "system.label.deleteUser": "Xóa người dùng",
    "system.label.areYouSure": "Bạn có chắc chắn không?",
    "system.label.ok": "Đồng ý",
    "system.label.editUser": "Chỉnh sửa người dùng",
    "system.label.availableRoles": "Vai trò khả dụng",
    "system.label.selectedRoles": "Vai trò đã chọn",
    "system.label.entity": "Thực thể",
    "system.label.submit": "Gửi",
    "system.label.createUser": "Tạo người dùng",
    "system.label.autoGeneratePassword": "Tự động tạo mật khẩu",
    "system.label.reset": "Đặt lại",
    "system.label.areYouSureDelete": "Bạn có chắc chắn muốn xóa không?",
    "system.label.confirm": "Xác nhận",
    "system.label.createRole": "Tạo vai trò",
    "system.label.name": "Tên",
    "system.label.description": "Mô tả",
    "system.label.permissions": "Quyền",
    "system.label.currencyConfig": "Cấu hình tiền tệ",
    "system.label.createCurrency": "Tạo tiền tệ",
    "system.label.code": "Mã",
    "system.label.internationalNameCode": "Mã tên quốc tế",
    "system.label.decimalPlaces": "Số chữ số thập phân",
    "system.label.displaySymbol": "Biểu tượng hiển thị",
    "system.label.viewCurrency": "Xem tiền tệ",
    "system.label.countryCode": "Mã quốc gia",
    "system.label.countryName": "Tên quốc gia",
    "system.label.displaySymbol": "Biểu tượng hiển thị",
    "system.label.createCurrencyMaster": "Tạo bảng chuyên môn về tiền tệ",
    "system.label.currency": "Tiền tệ",
    "system.label.nonCurrency": "Không phải tiền tệ",
    "system.label.editCurrencyConfiguration": "Chỉnh sửa cấu hình tiền tệ",
    "system.label.deleteCurrency": "Xóa tiền tệ",
    "system.label.deleteNonCurrency": "Xóa không phải tiền tệ",
    "system.label.areYouSureDelete": "Bạn có chắc chắn muốn xóa không?",
    "system.label.currencyExchange": "Giao dịch ngoại tệ",
    "system.label.createExchange": "Tạo giao dịch",
    "system.label.id": "Id",
    "system.label.baseCurrency": "Tiền tệ cơ sở",
    "system.label.conversionCurrency": "Tiền tệ chuyển đổi",
    "system.label.conversionRate": "Tỷ giá chuyển đổi",
    "system.label.status": "Trạng thái",
    "system.label.validFrom": "Hiệu lực từ",
    "system.label.validTo": "Hiệu lực đến",
    "system.label.deleteCurrencyExchange": "Xóa giao dịch ngoại tệ",
    "system.label.viewCurrencyExchange": "Xem giao dịch ngoại tệ",
    "system.label.createCurrencyExchange": "Tạo giao dịch ngoại tệ",
    "system.label.editCurrencyExchange": "Chỉnh sửa giao dịch ngoại tệ",
    "system.label.GlobalConfiguration": "Cấu hình toàn cầu",
    "system.label.Module": "Mô-đun",
    "system.label.Name": "Tên",
    "system.label.Description": "Mô tả",
    "system.label.Value": "Giá trị",
    "system.label.Enabled": "Đã kích hoạt",
    "system.label.Flag": "Cờ",
    "system.label.Action": "Hành động",
    "system.label.EditGlobalConfiguration": "Chỉnh sửa cấu hình toàn cầu",
    "system.label.PaymentGatewayConfiguration": "Cấu hình cổng thanh toán",
    "system.label.EditPaymentGatewayConfiguration":
      "Chỉnh sửa cấu hình cổng thanh toán",
    "system.label.Key": "Khóa",
    "system.label.EnterKeyHere": "Nhập khóa tại đây",
    "system.label.EnterValueHere": "Nhập giá trị tại đây",
    "system.label.Hooks": "Móc",
    "system.label.Event": "Sự kiện",
    "system.label.Name": "Tên",
    "system.label.Description": "Mô tả",
    "system.label.Value": "Giá trị",
    "system.label.Enabled": "Đã kích hoạt",
    "system.label.Flag": "Cờ",
    "system.label.Action": "Hành động",
    "system.label.Process": "Quá trình",
    "system.label.OrderBy": "Sắp xếp theo",
    "system.label.PrePost": "TrướcSau",
    "system.label.ProcessParams": "Thông số quá trình",
    "system.label.IsSynchronous": "Đồng bộ",
    "system.label.Actions": "Hành động",
    "system.label.CreateEvent": "Tạo sự kiện",
    "system.label.CreateEventActionMapping": "Tạo ánh xạ hành động sự kiện",
    "system.label.AutoGeneratePassword": "Tự động tạo mật khẩu",
    "system.label.EditEventActionMapping": "Chỉnh sửa ánh xạ hành động sự kiện",
    "system.label.ProvisioningDevice": "Thiết bị Cung cấp",
    "system.label.ItemClass": "Lớp Mục",
    "system.label.ProvisioningSystem": "Hệ thống Cung cấp",
    "system.label.Create": "Tạo",
    "system.label.CreateHardwarePlan": "Tạo Kế hoạch Phần cứng",
    "system.label.EditHardwarePlan": "Chỉnh sửa Kế hoạch Phần cứng",
    "system.label.ProvisionCommand": "Lệnh Cung cấp",
    "system.label.ProvisioningSystem": "Hệ thống Cung cấp",
    "system.label.CommandName": "Tên Lệnh",
    "system.label.Status": "Trạng thái",
    "system.label.Parameters": "Tham số",
    "system.label.CreateProvisioningMapping": "Tạo Bản đồ Cung cấp",
    "system.label.CommandParams": "Tham số Lệnh",
    "system.label.ParamDefault": "Giá trị Mặc định của Tham số",
    "system.label.ParamLength": "Độ dài của Tham số",
    "system.label.ParamNotes": "Ghi chú Tham số",
    "system.label.ParamType": "Loại Tham số",
    "system.label.AutoGenerate": "Tự động Tạo",
    "system.label.ViewProvisioningMapping": "Xem Bản đồ Cung cấp",
    "system.label.CommandParameter": "Tham số Lệnh",
    "system.label.Edit": "Chỉnh sửa",
    "system.label.Delete": "Xóa",
    "system.label.DeleteProvisionCommand": "Xóa Lệnh Cung cấp",
    "system.label.AreYouSure": "Bạn có chắc không?",
    "system.label.Ok": "Ok",
    "system.label.EditProvisioningMapping": "Chỉnh sửa Bản đồ Cung cấp",
    "system.label.Id": "Id",
    "system.label.ParamName": "Tên Tham Số",
    "system.label.ProvisioningActions": "Hành Động Cung Cấp",
    "system.label.ProvisionType": "Loại Cung Cấp",
    "system.label.IsEnable": "Được Kích Hoạt",
    "system.label.NetworkSystem": "Hệ Thống Mạng",
    "system.label.SystemCode": "Mã Hệ Thống",
    "system.label.SystemName": "Tên Hệ Thống",
    "system.label.CreateNetworkSystem": "Tạo Hệ Thống Mạng",
    "system.label.GroupSupported": "Nhóm Được Hỗ Trợ",
    "system.label.EditNetworkSystem": "Chỉnh Sửa Hệ Thống Mạng",
    "system.label.DeleteNetworkSystem": "Xóa Hệ Thống Mạng",
    "system.label.ManageReports": "Quản Lý Báo Cáo",
    "system.label.ReportName": "Tên Báo Cáo",
    "system.label.AddressMasterTreeView": "Chế độ xem cây của Danh bạ",
    "system.label.ReportType": "Loại Báo Cáo",
    "system.label.ReportSubtype": "Phân Loại Báo Cáo",
    "system.label.ReportCategory": "Danh Mục Báo Cáo",
    "system.label.CoreReport": "Báo Cáo Chính",
    "system.label.UserReport": "Báo Cáo Người Dùng",
    "system.label.CreateReport": "Tạo Báo Cáo",
    "system.label.ReportDetails": "Chi Tiết Báo Cáo",
    "system.label.UserReportUI": "Báo Cáo Người Dùng (UI)",
    "system.label.isScheduled": "Được Lên Lịch",
    "system.label.Description": "Mô Tả",
    "system.label.Sql": "SQL",
    "system.label.ReportParameters": "THAM SỐ BÁO CÁO",
    "system.label.AllowedParameters": "Tham Số Được Phép",
    "system.label.CreateParameter": "Tạo Tham Số",
    "system.label.Parameter": "Tham Số",
    "system.label.ParameterNamePassedToPentaoh":
      "Tên Tham Số Được Truyền Đến Pentaoh",
    "system.label.Reset": "Đặt Lại",
    "system.label.EditReport": "Chỉnh Sửa Báo Cáo",
    "system.label.DeleteReports": "Xóa Báo Cáo",
    "system.label.ManageCodes": "Quản Lý Mã",
    "system.label.CodeModule": "Mô-đun Mã",
    "system.label.SystemDefined": "Hệ Thống Định Nghĩa",
    "system.label.CreateCode": "Tạo Mã",
    "system.label.AddCode": "Thêm Mã",
    "system.label.Module": "Mô-đun",
    "system.label.EditManageCodes": "Chỉnh Sửa Quản Lý Mã",
    "system.label.CodeValue": "Giá Trị Mã",
    "system.label.Position": "Vị Trí",
    "system.label.Create": "Tạo",
    "system.label.DeleteManageCodes": "Xóa Quản Lý Mã",
    "system.label.ViewManageCodes": "Xem Quản Lý Mã",
    "system.label.Name": "Tên",
    "system.label.Add": "Thêm",
    "system.label.CodeName": "Tên Mã",
    "system.label.Submit": "Gửi",
    "system.label.isSynchronous": "Đồng bộ",

    "system.label.EnterServiceDescription": "Nhập mô tả dịch vụ",
    "system.label.Questions": "Câu hỏi",
    "system.label.Id": "ID",
    "system.label.QuestionType": "Loại câu hỏi",
    "system.label.QuestionText": "Nội dung câu hỏi",
  },
};
